export default {
  translation: {
    common: {
      confirm: 'Подтвердить',
      back: 'Назад',
      noResults: 'Результаты не найдены',
      selectPlaceholder: 'выберите значение',
      selectAll: 'Выбрать все',
      delete: 'Удалить',
      deleteModalTitle: 'Вы уверены, что хотите удалить этот элемент?',
      deleteThem: 'Вы уверены, что хотите удалить их?',
      ok: 'Да',
      cancel: 'Нет',
      yes: 'Да',
      no: 'Нет',
      total: 'Всего',
      rename: 'Переименовать',
      name: 'Название',
      save: 'Сохранить',
      namePlaceholder: 'Введите название',
      next: 'Далее',
      create: 'Создать',
      edit: 'Редактировать',
      upload: 'Загрузить',
      english: 'Английский',
      portugueseBr: 'Португальский (Бразилия)',
      chinese: 'Упрощенный китайский',
      traditionalChinese: 'Традиционный китайский',
      russian: 'Русский',
      language: 'Язык',
      languageMessage: 'Пожалуйста, укажите ваш язык!',
      languagePlaceholder: 'выберите язык',
      copy: 'Копировать',
      copied: 'Скопировано',
      comingSoon: 'Скоро будет',
      download: 'Скачать',
      close: 'Закрыть',
      preview: 'Предпросмотр',
      move: 'Переместить',
      warn: 'Предупреждение',
      action: 'Действие',
      s: 'S',
      pleaseSelect: 'Пожалуйста, выберите',
      pleaseInput: 'Пожалуйста, введите',
      submit: 'Отправить',
      clear: 'Очистить',
      embedIntoSite: 'Опубликовать',
      previousPage: 'Назад',
      nextPage: 'Вперед',
      add: 'Добавить',
      remove: 'Удалить',
      search: 'Поиск',
      noDataFound: 'Данные не найдены',
      noData: 'Нет доступных данных',
      promptPlaceholder:
        'Введите или используйте / для быстрой вставки переменных.',
      mcp: {
        namePlaceholder: 'Мой MCP сервер',
        nameRequired:
          'Должно быть 1–64 символа длиной и содержать только буквы, цифры, дефисы и символы подчеркивания.',
        urlPlaceholder: 'https://api.example.com/v1/mcp',
        tokenPlaceholder: 'напр. eyJhbGciOiJIUzI1Ni...',
      },
      selected: 'Выбрано',
      seeAll: 'Посмотреть все',
      agentFactory: 'Фабрика ИИ агентов',
    },
    login: {
      loginTitle: 'Войдите в свой аккаунт',
      signUpTitle: 'Создать аккаунт',
      login: 'Войти',
      signUp: 'Зарегистрироваться',
      loginDescription: 'Мы так рады видеть вас снова!',
      registerDescription: 'Рады приветствовать вас на борту!',
      emailLabel: 'Email',
      emailPlaceholder: 'Введите email',
      passwordLabel: 'Пароль',
      passwordPlaceholder: 'Введите пароль',
      rememberMe: 'Запомнить меня',
      signInTip: 'У вас еще нет аккаунта?',
      signUpTip: 'У вас уже есть аккаунт?',
      nicknameLabel: 'Псевдоним',
      nicknamePlaceholder: 'Введите псевдоним',
      register: 'Создать аккаунт',
      continue: 'Продолжить',
      title: 'Твой ИИ агент с базой знаний за 10 минут',
      start: 'Давайте начнем',
      description:
        'Зарегистрируйтесь бесплатно, чтобы исследовать лучшие RAG-технологии. Создавайте базы знаний и ИИ для расширения возможностей вашего бизнеса.',
      review: 'на основе более 500+ отзывов',
      seeAll: 'Посмотреть все отзывы',
    },
    header: {
      Root: 'Главная',
      knowledgeBase: 'Данные',
      chat: 'Чат',
      register: 'Зарегистрироваться',
      signin: 'Войти',
      home: 'Главная',
      setting: 'Настройки пользователя',
      logout: 'Выйти',
      fileManager: 'Файлы',
      flow: 'Агент',
      search: 'Поиск',
      welcome: 'Добро пожаловать в',
      dataset: 'Данные',
      memories: 'Память',
    },
    memories: {
      title: 'Память',
      llmTooltip:
        'Анализирует содержание разговора, извлекает ключевую информацию и генерирует структурированные резюме памяти.', //draft
      embeddingModelTooltip:
        'Преобразует текст в числовые векторы для поиска схожести по смыслу и извлечения памяти.', //draft
      embeddingModelError:
        'Тип памяти обязателен, а "исходная" не может быть удален.', //draft
      memoryTypeTooltip: `Исходная: Исходный контент диалога между пользователем и агентом (обязательно по умолчанию).
Семантическая память: Общие знания и факты о пользователе и мире.
Эпизодическая память: Записи конкретных событий и опытов с отметками времени.
Процедурная память: Изученные навыки, привычки и автоматизированные процедуры.`, //draft
      raw: 'исходная', //draft
      semantic: 'семантическая', //draft
      episodic: 'эпизодическая', //draft
      procedural: 'процедурная', //draft
      editName: 'Изменить имя', //draft
      memory: 'Память', //draft
      createMemory: 'Создать память', //draft
      name: 'Имя', //draft
      memoryNamePlaceholder: 'имя памяти', //draft
      memoryType: 'Тип памяти', //draft
      embeddingModel: 'Модель встраивания', //draft
      selectModel: 'Выбрать модель', //draft
      llm: 'LLM', //draft
      delMemoryWarn: `После удаления все сообщения в этой памяти будут удалены и не смогут быть восстановлены агентами.`, //draft
    },
    memory: {
      taskLogDialog: {
        title: 'Память',
        startTime: 'Время начала',
        status: 'Статус',
        details: 'Детали',

        success: 'Успешно',
        running: 'Выполняется',
        failed: 'Ошибка',
      },

      messages: {
        forget: 'Забыть', //draft
        forgetMessageTip: 'Вы уверены, что хотите забыть?', //draft
        messageDescription:
          'Память сконфигурирована с использованием промпта и Температуры из Расширенных настроек.', //draft
        copied: 'Скопировано!', //draft
        contentEmbed: 'Content embed', //draft
        content: 'Содержание', //draft
        delMessageWarn: `После забывания, это сообщение не будет извлечено агентами.`, //draft
        forgetMessage: 'Забыть сообщение', //draft
        sessionId: 'ID сессии', //draft
        agent: 'Агент', //draft
        type: 'Тип', //draft
        validDate: 'Дата действия', //draft
        forgetAt: 'Забыть в', //draft
        source: 'Источник', //draft
        enable: 'Включить', //draft
        action: 'Действие', //draft
      },
      config: {
        memorySizeTooltip: `Учитывает содержание каждого сообщения + его вектор встраивания (≈ Content + Dimensions × 8 Bytes).
Пример: Сообщение размером 1 КБ с 1024-мерным вектором занимает ~9 КБ. Лимит по умолчанию 5 МБ позволяет хранить ~500 таких сообщений.`, //draft
        avatar: 'Аватар', //draft
        description: 'Описание', //draft
        memorySize: 'Размер памяти', //draft
        advancedSettings: 'Расширенные настройки', //draft
        permission: 'Разрешение', //draft
        onlyMe: 'Только я', //draft
        team: 'Команда', //draft
        storageType: 'Тип хранилища', //draft
        storageTypePlaceholder: 'Выберите тип хранилища', //draft
        forgetPolicy: 'Политика забывания', //draft
        temperature: 'Температура', //draft
        systemPrompt: 'Системный промпт', //draft
        systemPromptPlaceholder: 'Пожалуйста, введите системный промпт', //draft
        userPrompt: 'Пользовательский промпт', //draft
        userPromptPlaceholder: 'Пожалуйста, введите пользовательский промпт', //draft
      },
      sideBar: {
        messages: 'Сообщения', //draft
        configuration: 'Конфигурация', //draft
      },
    },
    knowledgeList: {
      welcome: 'С возвращением',
      description: 'Какие базы знаний вы будете использовать сегодня?',
      createKnowledgeBase: 'Создать базу знаний',
      name: 'Название',
      namePlaceholder: 'Введите название!',
      doc: 'Документы',
      searchKnowledgePlaceholder: 'Поиск',
      noMoreData: 'Это все. Больше ничего нет.',
      parserRequired: 'Требуется метод разбиения',
    },
    knowledgeDetails: {
      metadata: {
        selectFiles: 'Выбрано {{count}} файлов',
        type: 'Тип',
        fieldNameInvalid:
          'Имя поля может содержать только буквы или символы подчеркивания.',
        builtIn: 'Встроенный',
        generation: 'Генерация',
        toMetadataSetting: 'Настройки генерации',
        toMetadataSettingTip: 'Настройте генерацию метаданных в Конфигурации.',
        descriptionTip:
          'Предоставьте описания или примеры, чтобы направить LLM при извлечении значений для этого поля. Если оставить пустым, будет использоваться имя поля.',
        restrictDefinedValuesTip:
          'Режим набора значений: ограничивает извлечение LLM только предустановленными значениями. Определите значения ниже.',
        valueExists:
          'Значение уже существует. Подтвердите для объединения дубликатов и объединения всех связанных файлов.',
        fieldNameExists:
          'Имя поля уже существует. Подтвердите для объединения дубликатов и объединения всех связанных файлов.',
        valueSingleExists:
          'Значение уже существует. Подтвердите для объединения дубликатов .',
        fieldSingleNameExists:
          'Имя поля уже существует. Подтвердите для объединения дубликатов .',
        fieldExists: 'Поле уже существует.',
        fieldSetting: 'Настройки поля',
        changesAffectNewParses: 'Изменения влияют только на новые разборы.',
        // editMetadataForDataset: 'Просмотр и редактирование метаданных для',
        restrictDefinedValues: 'Ограничить определенными значениями',
        metadataGenerationSettings: 'Настройки генерации метаданных',
        manageMetadataForDataset:
          'Управление метаданными для этого набора данных',
        manageMetadata: 'Управление метаданными',
        metadata: 'Метаданные',
        values: 'Значения',
        value: 'Значение',
        action: 'Действие',
        field: 'Поле',
        description: 'Описание',
        fieldName: 'Имя поля',
        editMetadata: 'Редактировать метаданные',
        deleteWarn: 'Этот {{field}} будет удален из всех связанных файлов',
        deleteManageFieldAllWarn:
          'Это поле и все его соответствующие значения будут удалены из всех связанных файлов.',
        deleteManageValueAllWarn:
          'Это значение будет удалено из всех связанных файлов.',
        deleteManageFieldSingleWarn:
          'Это поле и все его соответствующие значения будут удалены из этого файла.',
        deleteManageValueSingleWarn:
          'Это значение будет удалено из этого файла.',
        deleteSettingFieldWarn: `Это поле будет удалено; существующие метаданные не будут затронуты.`,
        deleteSettingValueWarn: `Это значение будет удалено; существующие метаданные не будут затронуты.`,
      },
      redoAll: 'Очистить существующие чанки',
      applyAutoMetadataSettings:
        'Применить глобальные настройки автоматического извлечения метаданных',
      parseFileTip: 'Вы уверены, что хотите разобрать файл?',
      parseFile: 'Парсить файл',
      emptyMetadata: 'Метаданные отсутствуют',
      metadataField: 'Поле метаданных',
      systemAttribute: 'Системный атрибут',
      localUpload: 'Локальная загрузка',
      fileSize: 'Размер файла',
      fileType: 'Тип файла',
      uploadedBy: 'Загружено пользователем',
      notGenerated: 'Не сгенерировано',
      generatedOn: 'Сгенерировано ',
      subbarFiles: 'Файлы',
      generateKnowledgeGraph:
        'Извлечение сущностей и связей из всех ваших документов в этом наборе данных. Процесс может занять некоторое время.',
      generateRaptor:
        'Выполняет рекурсивную кластеризацию и суммаризацию чанков документов для построения иерархической структуры дерева, позволяющей более контекстно-осведомленный поиск по длинным документам.',
      generate: 'Генерировать',
      raptor: 'RAPTOR',
      processingType: 'Тип обработки',
      dataPipeline: 'Пайплайн обработки данных',
      operations: 'Операции',
      taskId: 'ID задачи',
      duration: 'Продолжительность',
      details: 'Детали',
      status: 'Статус',
      task: 'Задача',
      startDate: 'Дата начала',
      source: 'Источник',
      fileName: 'Имя файла',
      datasetLogs: 'Логи',
      fileLogs: 'Файл',
      overview: 'Логи',
      success: 'Успешно',
      failed: 'Не удалось',
      completed: 'Завершено',
      datasetLog: 'Лог набора данных',
      created: 'Создано',
      learnMore: 'Встроенный пайплайн',
      pdfAnalyzer: 'Анализатор PDF',
      pdfAnalyzerContent: {
        description:
          'Разбор текста на изображениях или в PDF представляет собой сложный многоэтапный процесс, который включает определение макета страницы, классификация элементов макета (текст, заголовки, таблицы, формулы картинки) и далее извлечение машиночитаемой записи с помощью OCR и VLM.',
        parsers: {
          deepdoc:
            '<strong>DeepDOC</strong> - мета-парсер Infiniflow, не поддерживает русский язык в режиме OCR, но поддерживает при разборе структурированных pdf. Мета-парсер обладает продвинутыми средствами распознавания композиции документа: таблиц, изображений, формул',
          simple:
            '<strong>Простой</strong> - Базовый парсер который работает только со структурированный pdf (без изображений)',
          docling:
            '<strong>Docling</strong> - универсальный мета-парсер, поддерживающий русский язык в режиме OCR за счет использования проверенной OCR модели Tesseract. <strong>Ограниченно поддерживает рукописный русский язык.</strong>',
          doclingExternal:
            '<strong>DoclingExternal</strong> - аналогично предыдущему, но для развертывания на внешнем сервисе, что увеличивает производительность и позволяет использовать более широкий набор настроек, в том числе моделей OCR: Tesseract, MacOCR, EasyOCR и другие. <strong>Уверенно поддерживает рукописный русский язык.</strong> Данная опция должна быть предварительно настроена в разделе провайдеров моделей.',
          paddleocr:
            '<strong>PaddleOCR</strong> - эта набор парсеров и мета-парсеров, включая VLM для обработки документов любой сложности. Возможно, лучшее решение из существующих, но требует вычислительной мощности. Данная опция должна быть предварительно настроена в разделе провайдеров моделей.',
          mineru:
            '<strong>MinerU</strong> - мета-парсер, построенный ны базе <code>PaddleOCR</code>, поддерживающий расширенную идентификацию фактов документов, что позволяет работать с <strong>научными документами</strong> с наличием диаграмм и формул. Данная опция должна быть предварительно настроена в разделе провайдеров моделей.',
          tcadp:
            '<strong>TCADP</strong> - продвинутый корпоративный мета-парсер, доступный только из облака. Данная опция должна быть предварительно настроена в рабочем окружении приложения.',
        },
      },
      general: 'Общие',
      chunkMethodTab: 'Метод разбиения',
      testResults: 'Результаты',
      testSetting: 'Настройки',
      retrievalTesting: 'Тестирование поиска',
      retrievalTestingDescription:
        'Проведите тест поиска, чтобы проверить, может ли RAGu извлекать нужный контент для LLM.',
      Parse: 'Парсер',
      dataset: 'Набор данных',
      testing: 'Тестирование',
      files: 'файлы',
      configuration: 'Конфигурация',
      knowledgeGraph: 'Граф знаний',
      name: 'Название',
      namePlaceholder: 'Введите название!',
      doc: 'Документы',
      datasetDescription:
        'Пожалуйста, дождитесь завершения обработки файлов перед началом чата с ИИ.',
      addFile: 'Добавить',
      searchFiles: 'Поиск файлов',
      localFiles: 'Локальные файлы',
      emptyFiles: 'Создать пустой файл',
      webCrawl: 'Веб-сканер',
      chunkNumber: 'Количество чанков',
      uploadDate: 'Дата загрузки',
      chunkMethod: 'Метод разбиения',
      enabled: 'Включено',
      disabled: 'Отключено',
      action: 'Действие',
      parsingStatus: 'Статус обработки',
      parsingStatusTip:
        'Время обработки документов зависит от нескольких факторов. Активация таких функций, как Граф знаний, RAPTOR, Автоматическое извлечение вопросов или Автоматическое извлечение ключевых слов, значительно увеличит время обработки. Если индикатор выполнения застревает, ознакомьтесь с этими разделами FAQ:https://ragflow.io/docs/dev/faq#why-does-my-document-parsing-stall-at-under-one-percent.',
      processBeginAt: 'Начато в',
      processDuration: 'Длительность',
      progressMsg: 'Прогресс',
      noTestResultsForRuned:
        'Нет соответствующих результатов. Попробуйте изменить ваш запрос или параметры.',
      noTestResultsForNotRuned:
        'Тест еще не был запущен. Результаты появятся здесь.',
      testingDescription:
        'Проведите тест поиска, чтобы проверить, может ли RAGu находить нужный контент для LLM. Если вы изменили настройки (например, вес сходства ключевых слов или порог сходства), учтите, что эти изменения не сохранятся автоматически. Их необходимо применить в настройках ассистента или компонента Retrieval.',
      similarityThreshold: 'Порог сходства',
      similarityThresholdTip:
        'RAGu использует комбинацию взвешенного сходства ключевых слов и косинусного сходства векторов или реранжировочного балла. Этот параметр задает порог сходства между запросом и чанками. Чанки с баллом ниже порога исключаются. По умолчанию порог 0.2: только чанки с баллом ≥20 будут извлечены.',
      vectorSimilarityWeight: 'Вес сходства ключевых слов',
      vectorSimilarityWeightTip:
        'Задает вес сходства ключевых слов в общем балле. Сумма весов должна равняться 1.0.',
      keywordSimilarityWeight: 'Вес сходства ключевых слов',
      keywordSimilarityWeightTip:
        'Задает вес сходства ключевых слов в общем балле. Сумма весов должна равняться 1.0.',
      testText: 'Тестовый текст',
      testTextPlaceholder: 'Введите ваш вопрос здесь!',
      testingLabel: 'Тестирование',
      similarity: 'Комбинированное сходство',
      termSimilarity: 'Сходство терминов',
      vectorSimilarity: 'Сходство векторов',
      hits: 'Результаты',
      view: 'Просмотр',
      filesSelected: 'Выбрано файлов',
      upload: 'Загрузить',
      run: 'Обработать',
      runningStatus0: 'ОЖИДАНИЕ',
      runningStatus1: 'ОБРАБОТКА',
      runningStatus2: 'ОТМЕНЕНО',
      runningStatus3: 'УСПЕХ',
      runningStatus4: 'ОШИБКА',
      pageRanges: 'Диапазон страниц',
      pageRangesTip:
        'Диапазон страниц для обработки; страницы вне диапазона не обрабатываются.',
      fromPlaceholder: 'от',
      fromMessage: 'Укажите начальную страницу',
      toPlaceholder: 'до',
      toMessage: 'Укажите конечную страницу (не включается)',
      layoutRecognize: 'Анализатор PDF',
      layoutRecognizeTip:
        'Используйте модель для анализа макета PDF: заголовки, текстовые блоки, изображения, таблицы. При выборе "Простой" извлекается только текст из структурированного PDF (без изображений). Работает только с PDF, см. подсказку справа',
      taskPageSize: 'Размер задачи',
      taskPageSizeMessage: 'Укажите размер задачи!',
      taskPageSizeTip: `При распознавании макета PDF делится на части для параллельной обработки. Этот параметр задает размер каждой части. Больший размер уменьшает разделение непрерывного текста.`,
      addPage: 'Добавить страницу',
      greaterThan: 'Значение должно быть больше, чем "до"!',
      greaterThanPrevious: 'Значение должно быть больше предыдущего "до"!',
      selectFiles: 'Выбрать файлы',
      changeSpecificCategory: 'Изменить категорию',
      uploadTitle: 'Перетащите файлы для загрузки',
      uploadDescription:
        'Поддерживается единичная или пакетная загрузка. Для локального RAGu: лимит 1GB за раз, максимум 32 файла.',
      chunk: 'Чанк',
      bulk: 'Пакет',
      cancel: 'Отмена',
      close: 'Закрыть',
      rerankModel: 'Модель реранжирования',
      rerankPlaceholder: 'Выберите',
      rerankTip: `Если не выбрано, используется сходство векторов. Выбор модели увеличит время ответа.`,
      topK: 'Top-K',
      topKTip: `Количество чанков, отправляемых в модель реранжирования.`,
      delimiter: `Разделитель текста`,
      delimiterTip:
        'Разделитель может состоять из одного или нескольких символов. Для нескольких символов укажите их в обратных кавычках (``). Например: \\n`##`; разделит текст по переводам строк и заголовкам (##) и точкам с запятой.',
      enableChildrenDelimiter: 'Дочерние чанки используются для поиска',
      childrenDelimiter: 'Разделитель текста',
      childrenDelimiterTip:
        'Разделитель дочерних чанков может состоять из одного или нескольких символов. Для нескольких символов укажите их в обратных кавычках (``). Например: \\n`##`; разделит текст по переводам строк и заголовкам (##) и точкам с запятой.',

      html4excel: 'Excel в HTML',
      html4excelTip: `При отключении таблицы Excel парсятся в ключ-значение. При включении — в HTML-таблицы с разбивкой каждые 12 строк.`,
      autoKeywords: 'Авто-ключевые слова',
      autoKeywordsTip: `⚠️ Потребляет токены LLM. Автоматически извлекает N ключевых слов для каждого чанка. Проверьте ключевые слова в списке чанков.`,
      autoQuestions: 'Авто-вопросы',
      autoQuestionsTip: `⚠️ Потребляет токены LLM. Автоматически генерирует N вопросов для чанка. Проверьте вопросы в списке чанков.`,
      redo: 'Очистить существующие {{chunkNum}} чанков?',
      setMetaData: 'Установить метаданные',
      pleaseInputJson: 'Введите JSON',
      documentMetaTips: `<p>Метаданные в формате JSON (не индексируются). Добавляются в промпт LLM, если чанки документа включены в промпт.</p>
<p>Пример:</p>
<b>Метаданные:</b><br>
<code>
  {
      "Автор": "Алексей Доусов",
      "Дата": "2024-11-12"
  }
</code><br>
<b>Промпт будет:</b><br>
<p>Документ: название_документа</p>
<p>Автор: Алексей Доусов</p>
<p>Дата: 2024-11-12</p>
<p>Релевантные фрагменты:</p>
<ul>
<li>Содержимое чанка...</li>
<li>Содержимое чанка...</li>
</ul>
`,
      metaData: 'Метаданные',
      deleteDocumentConfirmContent:
        'Удаление документа также удалит связанные узлы и связи в графе знаний. Граф обновится при обработке нового документа с задачей извлечения графа.',
      plainText: 'Простой',
      reRankModelWaring: 'Модель реранжирования требует много времени.',
    },
    knowledgeConfiguration: {
      globalIndexModelTip:
        'Используется для генерации графов знаний, RAPTOR, автоматических метаданных, автоматических ключевых слов и автоматических вопросов. Производительность модели влияет на качество генерации.',
      globalIndexModel: 'Модель индексирования',
      settings: 'Настройки',
      autoMetadataTip: `⚠️ Потребляет токены LLM. Автоматически генерировать метаданные. Применяется к новым файлам при парсинге. Существующие файлы требуют повторного парсинга для обновления (чанки сохраняются). Обратите внимание, что дополнительные токены будут потребляться моделью индексирования, указанной в 'Конфигурации'.`,
      imageTableContextWindow: 'Окно контекста изображения и таблицы',
      imageTableContextWindowTip:
        'Захватывает N токенов текста выше и ниже изображения и таблицы для предоставления более богатого контекста.',
      autoMetadata: 'Автоматические метаданные',
      mineruOptions: 'MinerU опции',
      mineruParseMethod: 'Метод разбора',
      mineruParseMethodTip:
        'Метод для разбора PDF: auto (автоматическое определение), txt (извлечение текста), ocr (оптическое распознавание символов)',
      mineruFormulaEnable: 'Распознавание формул',
      mineruFormulaEnableTip:
        'Включить распознавание формул. Примечание: Это может работать некорректно для документов на кириллическом языке.',
      mineruTableEnable: 'Распознавание таблиц',
      mineruTableEnableTip: 'Включить распознавание и извлечение таблиц.',
      doclingOptions: 'Опции Docling',
      doOcr: 'Включить OCR',
      doOcrTip:
        'Если включено, растровое содержимое будет обрабатываться с помощью OCR.',
      forceOcr: 'Принудительный OCR',
      forceOcrTip:
        'Если включено, заменяет существующий текст на текст, сгенерированный OCR.',
      pdfBackend: 'PDF обработчик',
      pdfBackendTip: 'PDF обработчик, dlparse_v4 - самый продвинутый.',
      doclingTableMode: 'Режим таблиц',
      doclingTableModeTip:
        'Режим извлечения таблиц. Опции: fast (быстрый), accurate (точный).',
      doclingFormulaEnable: 'Распознавание формул',
      doclingFormulaEnableTip:
        'Включить распознавание формул. Примечание: может работать некорректно для документов на кириллице.',
      doclingTableEnable: 'Распознавание таблиц',
      doclingTableEnableTip: 'Включить распознавание и извлечение таблиц.',
      paddleocrOptions: 'Настройки PaddleOCR',
      paddleocrApiUrl: 'PaddleOCR API URL',
      paddleocrApiUrlTip: 'Ссылка на API PaddleOCR',
      paddleocrApiUrlPlaceholder:
        'например https://paddleocr-server.com/layout-parsing',
      paddleocrAccessToken: 'AI Studio Access Token',
      paddleocrAccessTokenTip:
        'Токен доступа для API PaddleOCR (необязательно)',
      paddleocrAccessTokenPlaceholder: 'Ваш токен AI Studio (необязательно)',
      paddleocrAlgorithm: 'PaddleOCR Algorithm',
      paddleocrAlgorithmTip: 'Алгоритм для разбора PaddleOCR',
      paddleocrSelectAlgorithm: 'Выберите алгоритм',
      paddleocrModelNamePlaceholder: 'например paddleocr-from-env-1',
      overlappedPercent: 'Процент перекрытия (%)',
      generationScopeTip:
        'Определяет, будет ли RAPTOR генерироваться для всего набора данных или для отдельного файла.',
      scopeDataset: 'Набор данных',
      generationScope: 'Область генерации',
      scopeSingleFile: 'Отдельный файл',
      autoParse: 'Автоматический разбор',
      rebuildTip:
        'Перезагружает файлы из связанного источника данных и парсит их снова.',
      baseInfo: 'Базовые',
      globalIndex: 'Глобальный индекс',
      dataSource: 'Источник данных',
      linkSourceSetTip:
        'Управление связью источника данных с этим набором данных',
      linkDataSource: 'Связать источник данных',
      tocExtraction: 'Извлечение оглавления PageIndex',
      tocExtractionTip:
        '⚠️ Потребляет токены LLM. Для существующих чанков генерируется иерархическое оглавление (одна директория на файл). Во время запросов, когда активировано улучшение директорий, система будет использовать большую модель для определения, какие элементы директории относятся к вопросу пользователя, тем самым выявляя соответствующие чанки. PageIndex - это облегченная альтернатива RAPTOR, используйте что-то одно в настройках',
      deleteGenerateModalContent: `
<p>Удаление сгенерированных <strong class='text-text-primary'>{{type}}</strong> результатов
приведет к удалению всех производных сущностей и связей из этого набора данных.
Ваши оригинальные файлы останутся нетронутыми.<p>
<br/>
Хотите продолжить?
      `,
      extractRaptor: 'Извлечь Raptor',
      extractKnowledgeGraph: 'Извлечь знания',
      filterPlaceholder: 'введите фильтр',
      fileFilterTip: '',
      fileFilter: 'Фильтр файлов',
      setDefaultTip: '',
      setDefault: 'Установить по умолчанию',
      editLinkDataPipeline: 'Редактировать пайплайн обработки данных',
      linkPipelineSetTip:
        'Управление связью пайплайна обработки данных с этим набором данных',
      default: 'По умолчанию',
      dataPipeline: 'Пайплайн обработки данных',
      linkDataPipeline: 'Связать пайплайн обработки данных',
      enableAutoGenerate: 'Включить автоматическую генерацию',
      teamPlaceholder: 'Пожалуйста, выберите команду.',
      dataFlowPlaceholder: 'Пожалуйста, выберите пайплайн.',
      buildItFromScratch: 'Создать с нуля',
      dataFlow: 'Пайплайн',
      parseType: 'Тип разбора',
      manualSetup: 'Выберите пайплайн',
      builtIn: 'Встроенный пайплайн',
      titleDescription:
        'Обновите настройки базы знаний, особенно метод разделения.',
      name: 'Название базы знаний',
      photo: 'Изображение базы',
      photoTip: 'Вы можете загрузить фото до 4 MB',
      description: 'Описание',
      language: 'Язык документов',
      languageMessage: 'Укажите язык!',
      languagePlaceholder: 'Выберите язык',
      permissions: 'Права доступа',
      embeddingModel: 'Модель эмбеддинга',
      chunkTokenNumber: 'Рекомендуемый размер чанка',
      chunkTokenNumberMessage: 'Укажите размер чанка в токенах',
      embeddingModelTip:
        'Модель для преобразования чанков в эмбеддинги. Нельзя изменить после создания чанков. Для смены модели удалите все чанки.',
      permissionsTip:
        'При выборе "Команда" все участники смогут управлять базой знаний.',
      chunkTokenNumberTip:
        'Порог токенов для создания чанка. Сегменты объединяются, пока не превысят порог. Чанк создается при обнаружении разделителя.',
      chunkMethod: 'Метод разбиения',
      chunkMethodTip:
        'Встроенный пайплайн настраивается на данной странице в противоположность внешнему пайплайну, настраиваемого в разделе "Агент". См. подробныое описание встроенных пайплайнов по кнопке "Встроенный пайплайн"',
      upload: 'Загрузить',
      english: 'Английский',
      chinese: 'Китайский',
      portugueseBr: 'Португальский (Бразилия)',
      embeddingModelPlaceholder: 'Выберите модель эмбеддинга',
      chunkMethodPlaceholder: 'Выберите метод разделения',
      save: 'Сохранить',
      me: 'Только я',
      team: 'Команда',
      cancel: 'Отмена',
      methodTitle: 'Описание метода',
      methodExamples: 'Примеры',
      methodExamplesDescription: 'Примеры для наглядности:',
      dialogueExamplesTitle: 'Просмотр',
      methodEmpty: 'Отображение визуального объяснения категорий',
      book: `<p>Поддерживаемые форматы: <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      Для PDF укажите диапазон страниц, чтобы сократить время анализа.</p>`,
      laws: `<p>Поддерживаемые форматы: <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
      Юридические документы имеют строгий формат поэтому используются специальные свойства для разбиения текста по статьям.
      </p><p>
      Разделение происходит по статьям, что гарантирует включение всего текста вышестоящих уровней в чанк.
      </p>`,
      manual: `<p>Только <b>PDF</b>.</p><p>
      Разделение по заголовкам разделов. Изображения и таблицы в одном разделе не разделяются.
      </p>`,
      naive: `<p>Поддерживаемые форматы: <b>DOCX, XLSX, XLS, PPT, PDF, TXT, JPEG, JPG, PNG, TIF, GIF, CSV, JSON, EML, HTML</b>.</p>
      <p>Метод "наивного" разделения: </p>
      <p>
      <li>Визуальное разделение текста на сегменты.</li>
      <li>Объединение сегментов до достижения порога токенов.</li></p>`,
      paper: `<p>Поддерживаются только <b>PDF</b>.</p><p>
      Статьи будут разделены по разделам, таким как <i>аннотация, 1.1, 1.2</i>. </p><p>
      Такой подход позволяет LLM более эффективно резюмировать статью и давать более полные и понятные ответы.
      Однако это также увеличивает контекст для общения с ИИ и повышает вычислительные затраты для LLM. Поэтому во время разговора стоит рассмотреть возможность уменьшения значения параметра '<b>topN</b>'.`,
      presentation: `<p>Поддерживаемые форматы: <b>PDF</b>, <b>PPTX</b>.</p><p>
      Каждая страница слайдов — отдельный чанк с миниатюрой.</p><p>
      <i>Этот метод разбиения автоматически применяется ко всем загруженным PPT-файлам, поэтому указывать его вручную не нужно.</i></p>`,
      qa: `
<p>
Этот метод поддерживает форматы: <b>XLSX</b>, <b>CSV/TXT</b>.
</p>
<li>
Если файл приведен в формате <b>XLSX</b> или <b>XLS (Excel97~2003)</b>, он должен содержать две колонки без заголовков: 
одну для вопросов и другую для ответов, при этом колонка с вопросами должна идти первой. Допускается наличие нескольких листов, при условии, что колонки структурированы правильно.
</li>
<li>
Если файл находится в формате <b>CSV/TXT</b>, он должен быть в кодировке UTF-8 с использованием символа TAB в качестве разделителя между вопросами и ответами.
</li>
<p>
<i>
  Строки текста, не соответствующие вышеуказанным правилам, будут игнорироваться, 
  а каждая пара вопрос–ответ будет рассматриваться как отдельный фрагмент.
</i>
</p>
      `,
      resume: `<p>Поддерживаемые форматы: <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
      </p><p>
      Резюме парсятся в структурированные данные для поиска кандидатов.
      </p>
      `,
      table: `<p>Поддерживаемые форматы файлов: <b>XLSX</b> и <b>CSV/TXT</b>.</p><p>
      Требования и рекомендации:
      <ul>
    <li>Для CSV/TXT файлов разделителем колонок должен быть <em><b>TAB</b></em>.</li>
    <li>Первая строка должна содержать заголовки колонок.</li>
    <li>Заголовки должны быть осмысленными для лучшего понимания LLM.
    Рекомендуется указывать синонимы через слэш <i>'/'</i> и перечислять значения в скобках, например: <i>'Пол (мужской, женский)'</i>.<p>
    Примеры заголовков:<ol>
        <li>поставщик/вендор<b>'TAB'</b>Цвет (Желтый, Синий, Коричневый)<b>'TAB'</b>Пол (мужской, женский)<b>'TAB'</b>Размер (S, M, L, XL)</li>
        </ol>
        </p>
    </li>
    <li>Каждая строка таблицы будет обрабатываться как отдельный чанк.</li>
    </ul>`,
      picture: `
<p>Поддерживаются изображения, поддержка видео появится позже.</p><p>
Используется OCR-модель для извлечения текста из изображений.
</p><p>
Если извлеченного текста недостаточно, специальная визуальная LLM сгенерирует описание изображения.
</p>`,
      one: `
<p>Поддерживаемые форматы: <b>DOCX, XLSX, XLS (Excel97~2003), PDF, TXT</b>.
</p><p>
Весь документ обрабатывается как единый чанк.
</p><p>
Подходит, когда требуется, чтобы LLM обработала весь документ целиком (при условии поддержки соответствующего контекста).
</p>`,
      knowledgeGraph: `<p>Поддерживаемые форматы: <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>

    <p>Используется 'наивный'/'Общий' метод чанкинга. Документ разделяется на сегменты, которые объединяются, пока количество токенов не превысит указанный порог.</p>
    <p>Затем чанки передаются в LLM для извлечения сущностей и связей, формируя граф знаний и ментальную карту.</p>
    <p>Не забудьте указать <b>Типы сущностей</b>.</p>`,
      tag: `<p>База знаний с методом чанкинга 'Тег' используется как набор тегов. Другие базы могут применять эти теги для своих чанков, а запросы к ним будут автоматически тегироваться.</p>
    <p>Такие базы <b>НЕ</b> участвуют в Retrieval-Augmented Generation (RAG).</p>
    <p>Каждый чанк здесь представляет собой пару "описание-тег".</p>
    <p>Поддерживаемые форматы: <b>XLSX</b> и <b>CSV/TXT</b>:</p>
    <p>Для <b>XLSX</b> требуется два столбца без заголовков: описание тега и сам тег (в указанном порядке). Допустимы несколько листов.</p>
    <p>Для <b>CSV/TXT</b> файлов используйте кодировку UTF-8 с разделителем TAB между описанием и тегом.</p>
    <p>В колонке тегов разделяйте значения <b>запятыми</b>.</p>
    <i>Строки, не соответствующие правилам, будут игнорироваться.</i>
    `,
      useRaptor: 'Использовать RAPTOR для улучшения поиска',
      useRaptorTip:
        '⚠️ Потребляет токены LLM. Рекурсивная абстрактная обработка для древовидного поиска. Подробнее: https://huggingface.co/papers/2401.18059',
      prompt: 'Промпт',
      promptTip:
        'Опишите задачу для LLM, укажите требования к ответу и другие параметры. Используйте переменные в фигурных скобках {} или кнопку (x) для их вставки.',
      promptMessage: 'Необходимо указать промпт',
      promptText: `Обобщите следующий текст. Будьте внимательны с числами и фактами. Текст:
      {cluster_content}
Выше содержание, которое нужно обобщить.`,
      maxToken: 'Макс. токенов',
      maxTokenTip: 'Максимальное количество токенов в обобщающем чанке.',
      maxTokenMessage: 'Необходимо указать значение',
      threshold: 'Порог',
      thresholdTip:
        'В RAPTOR чанки группируются по семантическому сходству. Чем выше порог, тем меньше чанков в кластере (и наоборот).',
      thresholdMessage: 'Необходимо указать значение',
      maxCluster: 'Макс. кластеров',
      maxClusterTip: 'Максимальное количество кластеров.',
      maxClusterMessage: 'Необходимо указать значение',
      randomSeed: 'Случайное зерно',
      randomSeedMessage: 'Необходимо указать значение',
      entityTypes: 'Типы сущностей',
      vietnamese: 'Вьетнамский',
      pageRank: 'Ранг страницы ',
      pageRankTip: `Вы можете назначить более высокий ранг страницы для определенных баз знаний при поиске. Это значение добавляется к гибридным показателям сходства найденных чанков из этих баз, повышая их рейтинг. Подробнее: https://ragflow.io/docs/dev/set_page_rank`,
      tagName: 'Тег',
      frequency: 'Частота',
      searchTags: 'Поиск тегов',
      tagCloud: 'Облако',
      tagTable: 'Таблица',
      tagSet: 'Наборы тегов',
      tagSetTip: `
<p>Выберите одну или несколько баз тегов для автоматической разметки чанков в вашей базе знаний. Подробнее: https://ragflow.io/docs/dev/use_tag_sets</p>
<p>Запросы пользователей также будут автоматически тегироваться.</p>
Автоматическая разметка тегами улучшает поиск, добавляя дополнительный уровень предметно-ориентированных знаний.
<p>Разница между авто-тегами и авто-ключами:</p>
<ul>
  <li>База тегов - это определенный пользователем закрытый набор, тогда как ключевые слова, извлекаемые LLM, можно считать открытым набором.</li>
  <li>Перед использованием авто-разметки необходимо загрузить наборы тегов в указанных форматах.</li>
  <li>Функция авто-ключей зависит от LLM и потребляет значительное количество токенов.</li>
</ul>
`,
      topnTags: 'TopN тегов',
      tags: 'Теги',
      addTag: 'Добавить тег',
      useGraphRag: 'Извлечь граф знаний',
      useGraphRagTip:
        '⚠️ Потребляет токены LLM. Построение графа знаний на основе чанков текущей базы для улучшения обработки многошаговых вопросов с вложенной логикой. Подробнее: https://ragflow.io/docs/dev/construct_knowledge_graph',
      graphRagMethod: 'Метод',
      graphRagMethodTip: `Light: (По умолчанию) Использует промпты от github.com/HKUDS/LightRAG. Потребляет меньше токенов и ресурсов.</br>
General: Использует промпты от github.com/microsoft/graphrag`,
      resolution: 'Слияние сущностей',
      resolutionTip: `При включении LLM будет объединять похожие сущности (например, "2025" и "год 2025", "IT" и "Информационные технологии") для построения более точного графа`,
      community: 'Отчеты сообществ',
      communityTip:
        'В графе знаний сообщество - это кластер связанных сущностей. LLM может генерировать сводку для каждого сообщества. Подробнее: https://www.microsoft.com/en-us/research/blog/graphrag-improving-global-search-via-dynamic-community-selection/',
      theDocumentBeingParsedCannotBeDeleted:
        'Документ в процессе обработки нельзя удалить',
      lastWeek: 'прошлая неделя',
    },
    chunk: {
      type: 'Тип',
      docType: {
        image: 'Изображение',
        table: 'Таблица',
        text: 'Текст',
      },
      chunk: 'Чанк',
      bulk: 'Пакетная',
      selectAll: 'Выбрать все',
      enabledSelected: 'Включить выбранные',
      disabledSelected: 'Отключить выбранные',
      deleteSelected: 'Удалить выбранные',
      search: 'Поиск',
      all: 'Все',
      enabled: 'Включено',
      disabled: 'Отключено',
      keyword: 'Ключевое слово',
      image: 'Изображение',
      imageUploaderTitle:
        'Загрузите новое изображение для обновления этого чанка изображения',
      function: 'Функция',
      chunkMessage: 'Пожалуйста, введите значение!',
      full: 'Полный текст',
      ellipse: 'Сокращение',
      graph: 'Граф знаний',
      mind: 'Ментальная карта',
      question: 'Вопрос',
      questionTip: `Если указаны вопросы, эмбеддинг чанка будет основан на них.`,
      chunkResult: 'Результат чанка',
      chunkResultTip: `Просмотр чанков, используемых для эмбеддинга и извлечения.`,
      documentPreview: 'Предпросмотр документа',
      enable: 'Включить',
      disable: 'Выключить',
      delete: 'Удалить',
    },
    chat: {
      messagePlaceholder: 'Введите ваше сообщение здесь...',
      exit: 'Выход',
      multipleModels: 'Несколько моделей',
      applyModelConfigs: 'Применить конфигурации модели',
      conversations: 'Диалоги',
      chatApps: 'Чат',
      newConversation: 'Новый диалог',
      createAssistant: 'Создать ассистента',
      assistantSetting: 'Настройки ассистента',
      appearanceSettings: 'Настройки внешнего вида',
      retrievalSettings: 'Настройки поиска',
      promptEngine: 'Система промптов',
      basicPromptSettings: 'Базовые настройки промптов',
      advancedPromptSettings: 'Расширенные настройки промптов',
      modelSetting: 'Настройки модели',
      chat: 'Чат',
      newChat: 'Новый чат',
      send: 'Отправить',
      sendPlaceholder: 'Сообщение ассистенту...',
      chatConfiguration: 'Настройки чата',
      chatConfigurationDescription:
        'Настройте чат-ассистента для выбранных баз знаний здесь',
      assistantName: 'Имя ассистента',
      assistantNameMessage: 'Требуется указать имя ассистента',
      namePlaceholder: 'Например: Роман Яров',
      assistantAvatar: 'Аватар ассистента',
      language: 'Язык',
      emptyResponse: 'Пустой ответ',
      emptyResponseTip: `Установите этот ответ, если по вашему запросу не найдено результатов в базах знаний. Оставьте поле пустым, чтобы LLM могла импровизировать.`,
      emptyResponseMessage: `Пустой ответ срабатывает, когда ничего не найдено. Очистите это поле, если не выбрана ни одна база знаний.`,
      setAnOpener: 'Приветственное сообщение',
      setAnOpenerInitial: `Привет! Я ваш помощник. Чем могу помочь?`,
      setAnOpenerTip: 'Установите приветственное сообщение для пользователей.',
      knowledgeBases: 'Базы знаний',
      knowledgeBasesMessage: 'Пожалуйста, выберите',
      knowledgeBasesTip: 'Выберите базы знаний для этого чат-ассистента.',
      system: 'Системный промпт',
      systemInitialValue: `Вы интеллектуальный помощник. 
Ваша основная функция - отвечать на вопросы, строго основываясь на предоставленной базе знаний.
**Основные правила:**
  - Ваш ответ должен быть получен **исключительно** из этой базы знаний: \`{knowledge}\`.
  - **Когда информация доступна**: Суммируйте содержание, чтобы дать подробный ответ.
  - **Когда информация недоступна**: Ваш ответ должен содержать это точное предложение: "Ответ, который вы ищете, не найден в базе знаний!"
  - **Всегда учитывайте** всю историю разговора.`,
      systemMessage: 'Пожалуйста, введите!',
      systemTip:
        'Ваши инструкции для LLM, включая роль, желаемую длину, тон и язык ответов.',
      topN: 'Top-N',
      topNTip: `Не все чанки с баллом выше порога сходства будут отправлены в LLM. Выбираются Top-N чанков из найденных.`,
      variable: 'Переменная',
      variableTip: `Используйте переменные вместе с API управления ассистентами RAGu для гибких стратегий промптов. {knowledge} - зарезервированная переменная для чанков из баз знаний. Подробнее: https://ragflow.io/docs/dev/set_chat_variables`,
      add: 'Добавить',
      key: 'Ключ',
      optional: 'Опционально',
      operation: 'Действие',
      model: 'Модель',
      modelTip: 'Большая языковая модель',
      modelMessage: 'Пожалуйста, выберите!',
      modelEnabledTools: 'Выбранный инструмент',
      modelEnabledToolsTip:
        'Выберите один или несколько инструментов для использования в модели чата. Это не работает для моделей, не поддерживающих вызов инструментов.',
      freedom: 'Свобода',
      improvise: 'Импровизация',
      precise: 'Точность',
      balance: 'Баланс',
      custom: 'Пользовательские',
      freedomTip: `Сокращенные настройки "Температуры", "Top-P" и штрафов. "Импровизация" - креативные ответы, "Точность" - консервативные, "Баланс" - промежуточный вариант.`,
      temperature: 'Температура',
      temperatureMessage: 'Требуется указать температуру',
      temperatureTip: `Контролирует случайность предсказаний модели. Низкие значения дают консервативные ответы, высокие - креативные.`,
      topP: 'Top-P',
      topPMessage: 'Требуется указать Top-P',
      topPTip:
        'Метод "ядерной выборки": устанавливает порог для выбора наиболее вероятных слов, отсекая маловероятные варианты.',
      presencePenalty: 'Штраф за повторение',
      presencePenaltyMessage: 'Требуется указать штраф',
      presencePenaltyTip:
        'Снижает вероятность повторения уже упомянутой информации.',
      frequencyPenalty: 'Штраф за частоту',
      frequencyPenaltyMessage: 'Требуется указать штраф',
      frequencyPenaltyTip: 'Снижает частоту повторения одних и тех же слов.',
      maxTokens: 'Макс. токенов',
      maxTokensMessage: 'Требуется указать макс. токенов',
      maxTokensTip: `Максимальная длина ответа модели (в токенах). По умолчанию 512. Отключение снимает ограничение.`,
      maxTokensInvalidMessage: 'Введите корректное число для макс. токенов.',
      maxTokensMinMessage: 'Макс. токенов не может быть меньше 0.',
      quote: 'Показывать цитату',
      quoteTip: 'Отображать исходный текст как ссылку.',
      selfRag: 'Self-RAG',
      selfRagTip: 'См.: https://huggingface.co/papers/2310.11511',
      overview: 'ID чата',
      pv: 'Количество сообщений',
      uv: 'Количество активных пользователей',
      speed: 'Скорость вывода токенов',
      tokens: 'Потрачено токенов',
      round: 'Количество сессий',
      thumbUp: 'Удовлетворенность клиентов',
      preview: 'Предпросмотр',
      embedded: 'Встроенный',
      serviceApiEndpoint: 'API Endpoint сервиса',
      apiKey: 'API KEY',
      apiReference: 'Документация API',
      dateRange: 'Диапазон дат:',
      backendServiceApi: 'API Сервер',
      createNewKey: 'Создать новый ключ',
      created: 'Создано',
      action: 'Действие',
      embedModalTitle: 'Опубликовать',
      comingSoon: 'Скоро будет',
      fullScreenTitle: 'Полное встраивание',
      fullScreenDescription:
        'Вставьте следующий iframe в нужное место на вашем сайте',
      partialTitle: 'Частичное встраивание',
      extensionTitle: 'Расширение Chrome',
      tokenError: 'Сначала создайте API ключ.',
      betaError: 'Получите API ключ RAGu на странице системных настроек.',
      searching: 'Поиск...',
      parsing: 'Обработка',
      uploading: 'Загрузка',
      uploadFailed: 'Ошибка загрузки',
      regenerate: 'Сгенерировать заново',
      read: 'Чтение содержимого',
      tts: 'Текст в речь',
      ttsTip:
        'Выберите модель TTS в настройках перед включением этой функции для воспроизведения текста как аудио.',
      relatedQuestion: 'Связанный вопрос',
      answerTitle: 'R',
      multiTurn: 'Многошаговая оптимизация',
      multiTurnTip:
        'Оптимизирует пользовательские запросы с учетом контекста многораундовой беседы. При включении расходует дополнительные токены LLM.',
      howUseId: 'Как использовать ID чата?',
      description: 'Описание ассистента',
      descriptionPlaceholder: 'Например: Чат-ассистент для резюме.',
      useKnowledgeGraph: 'Использовать граф знаний',
      useKnowledgeGraphTip:
        '⚠️ Потребляет токены для извлечения ключевых слов. Использовать графы знаний в указанных базах знаний для ответов на многошаговые вопросы. При включении выполняет итеративный поиск по сущностям, связям и отчетам сообществ, что значительно увеличивает время поиска.',
      keyword: 'Анализ ключевых слов',
      keywordTip: `Использовать LLM для анализа вопросов пользователя и выделения ключевых слов, которые будут учитываться при вычислении релевантности.`,
      languageTip:
        'Позволяет перефразировать запрос на указанном языке или использовать последний вопрос, если язык не выбран.',
      avatarHidden: 'Скрыть аватар',
      locale: 'Локаль',
      selectLanguage: 'Выберите язык',
      reasoning: 'Логические рассуждения',
      reasoningTip: `Включение пошаговых логических рассуждений при ответах на вопросы, как в моделях Deepseek-R1 или OpenAI o1. Позволяет модели использовать внешние знания и решать сложные вопросы поэтапно, применяя методы типа "цепочки рассуждений". Улучшает точность ответов за счет разбиения проблем на управляемые этапы.`,
      tavilyApiKeyTip:
        'При наличии API ключа Tavily будут использоваться веб-поиски для дополнения результатов из базы знаний.',
      tavilyApiKeyMessage: 'Введите ваш Tavily API Key',
      tavilyApiKeyHelp: 'Как получить?',
      crossLanguage: 'Мультиязыковой поиск',
      crossLanguageTip: `⚠️ Потребляет токены для перевода. Выберите один или несколько языков для мультиязыкового поиска. Не выбирайте язык, если хотите сделать простой запрос из соображений экономии времени и токенов.`,
      createChat: 'Создать чат',
      metadata: 'Метаданные',
      metadataTip:
        'Фильтрация метаданных - это процесс использования атрибутов метаданных (таких как теги, категории или разрешения доступа) для уточнения и контроля получения соответствующей информации в системе.',
      conditions: 'Условия',
      metadataKeys: 'Фильтруемые элементы',
      addCondition: 'Добавить условие',
      meta: {
        disabled: 'Отключено',
        auto: 'Автоматически',
        manual: 'Вручную',
        semi_auto: 'Полуавтоматически',
      },
      cancel: 'Отмена',
      chatSetting: 'Настройки чата',
      tocEnhance: 'PageIndex',
      tocEnhanceTip: `В процессе обработки документа было сгенерировано содержание (см. опцию "Извлечение оглавления PageIndex" в общем методе). Это позволяет модели возвращать элементы оглавления, соответствующие запросу пользователя, а затем использовать эти элементы для извлечения связанных фрагментов и применения веса к этим фрагментам при сортировке. Этот подход имитирует поведенческую логику поиска знаний в книгах людьми.`,
      batchDeleteSessions: 'Пакетное удаление сессий',
      deleteSelectedConfirm: 'Удалить выбранные {count} сессий?',
    },
    setting: {
      Verify: 'Проверить',
      keyValid: 'Ваш API ключ действителен.',
      keyInvalid: 'Ваш API ключ недействителен.',
      deleteModel: 'Удалить модель',
      bedrockCredentialsHint:
        'Подсказка: Оставьте Access Key / Secret Key пустыми, чтобы использовать аутентификацию AWS IAM.',
      awsAuthModeAccessKeySecret: 'Ключ доступа',
      awsAuthModeIamRole: 'IAM роль',
      awsAuthModeAssumeRole: 'Принять роль',
      awsAccessKeyId: 'AWS Access Key ID',
      awsSecretAccessKey: 'AWS Secret Access Key',
      awsRoleArn: 'AWS Role ARN',
      awsRoleArnMessage: 'Пожалуйста, введите AWS Role ARN',
      awsAssumeRoleTip:
        'Если вы выберете этот режим, Amazon EC2 экземпляр будет использовать свою существующую роль для доступа к службам AWS. Дополнительные учетные данные не требуются.',
      modelEmptyTip:
        'Нет доступных моделей. <br>Пожалуйста, добавьте модели из панели справа.',
      sourceEmptyTip:
        'Нет добавленных источников данных. Выберите один из них ниже для подключения.',
      seconds: 'секунды',
      minutes: 'минуты',
      edit: 'Редактировать',
      cropTip:
        'Перетащите область выделения, чтобы выбрать позицию обрезки изображения, и прокрутите, чтобы увеличить/уменьшить',
      cropImage: 'Обрезать изображение',
      selectModelPlaceholder: 'Выберите модель',
      configureModelTitle: 'Настроить модель',
      connectorNameTip: 'Описание имени коннектора',
      confluenceIsCloudTip:
        'Проверить, является ли это экземпляром Confluence Cloud, снимите флажок для Confluence Server/Data Center',
      confluenceWikiBaseUrlTip:
        'Базовый URL вашего экземпляра Confluence (например, https://your-domain.atlassian.net/wiki)',
      confluenceSpaceKeyTip:
        'Дополнительно: Уточните ключ пространства, чтобы ограничить синхронизацию конкретным пространством. Оставьте пустым для синхронизации всех доступных пространств. Для нескольких пространств разделяйте запятыми (например, DEV,DOCS,HR)',
      s3PrefixTip: `Уточните путь к папке внутри вашего S3 бакета, чтобы извлечь файлы.
Пример: general/v2/`,
      S3CompatibleEndpointUrlTip: `Требуется для совместимого хранилища S3. Укажите URL-адрес конечной точки, совместимый с S3.
Пример: https://fsn1.your-objectstorage.com`,
      S3CompatibleAddressingStyleTip: `Требуется для совместимого хранилища S3. Укажите стиль адресации, совместимый с S3.
Пример: Virtual Hosted Style`,
      addDataSourceModalTitle: 'Создать ваш {{name}} коннектор',
      deleteSourceModalTitle: 'Удалить источник данных',
      deleteSourceModalContent: `
<p>Вы уверены, что хотите удалить эту ссылку на источник данных?</p>`,
      deleteSourceModalConfirmText: 'Подтвердить',
      errorMsg: 'Сообщение об ошибке',
      newDocs: 'Новые документы',
      timeStarted: 'Время начала',
      log: 'Журнал',
      confluenceDescription:
        'Интегрируйте ваше рабочее пространство Confluence для поиска документации.',
      s3Description:
        'Подключитесь к вашему бакету AWS S3 для импорта и синхронизации хранящихся файлов.',
      google_cloud_storageDescription:
        'Подключитесь к вашему бакету Google Cloud Storage для импорта и синхронизации файлов.',
      r2Description:
        'Подключитесь к вашему бакету Cloudflare R2 для импорта и синхронизации файлов.',
      oci_storageDescription:
        'Подключитесь к вашему бакету Oracle Cloud Object Storage для импорта и синхронизации файлов.',
      discordDescription:
        'Подключите ваш сервер Discord для доступа и анализа данных чата.',
      notionDescription:
        'Синхронизируйте страницы и базы данных из Notion для поиска знаний.',
      google_driveDescription:
        'Подключитесь к вашему Google Drive через OAuth и синхронизируйте конкретные папки или диски.',
      gmailDescription:
        'Подключитесь к вашему Gmail через OAuth для синхронизации электронной почты.',
      webdavDescription:
        'Подключитесь к серверам WebDAV для синхронизации файлов.',
      webdavRemotePathTip:
        'Дополнительно: Укажите путь к папке на сервере WebDAV (например, /Documents). Оставьте пустым для синхронизации из корня.',
      google_driveTokenTip:
        'Загрузите JSON-токен OAuth, сгенерированный с помощью OAuth helper или Google Cloud Console. Вы также можете загрузить JSON-файл client_secret из приложения "installed" или "web". Если это ваш первый синхронизационный запуск, откроется окно браузера для завершения согласия OAuth. Если JSON уже содержит токен обновления, он будет автоматически повторно использован.',
      google_drivePrimaryAdminTip:
        'Адрес электронной почты, имеющий доступ к содержимому Google Drive, которое синхронизируется',
      zendeskDescription:
        'Подключите ваш Zendesk для синхронизации тикетов, статей и других контентов.',
      google_driveMyDriveEmailsTip:
        'Список адресов электронной почты, чьи "Мои документы" должны быть проиндексированы (включая основного администратора).',
      google_driveSharedFoldersTip:
        'Папки Google Drive, которые нужно проиндексировать (через ссылки).',
      gmailPrimaryAdminTip:
        'Основной адрес электронной почты с доступом к Gmail / Workspace, используемый для перечисления пользователей домена и как учетная запись по умолчанию для синхронизации.',
      gmailTokenTip:
        'Загрузите JSON-токен OAuth, сгенерированный из Google Console. Если он содержит только учетные данные клиента, выполните однократную проверку в браузере, чтобы получить долговременные токены обновления.',
      dropboxDescription:
        'Подключитесь к вашему Dropbox для синхронизации файлов и папок из выбранной учетной записи.',
      bitbucketDescription:
        'Подключитесь к Bitbucket для синхронизации содержимого PR.',
      bitbucketTopWorkspaceTip:
        'Рабочая область Bitbucket для индексации (например, "atlassian" из https://bitbucket.org/atlassian/workspace ).',
      bitbucketRepositorySlugsTip:
        'Репозитории, которые нужно проиндексировать (через запятую). например, repo-one, repo-two',
      bitbucketProjectsTip:
        'Проекты, которые нужно проиндексировать (через запятую). например, PROJ1,PROJ2',
      bitbucketWorkspaceTip:
        'Коннектор будет индексировать все репозитории в рабочей области.',
      boxDescription:
        'Подключитесь к вашему Box для синхронизации файлов и папок.',

      githubDescription:
        'Подключитесь к GitHub для синхронизации pull requests и issues.',
      airtableDescription:
        'Подключитесь к Airtable и синхронизируйте файлы из указанной таблицы в заданной рабочей области.',
      gitlabDescription:
        'Подключитесь к GitLab для синхронизации репозиториев, задач, запросов на слияние и связанной документации.',
      asanaDescription:
        'Подключитесь к Asana и синхронизируйте файлы из указанной рабочей области.',
      imapDescription:
        'Подключитесь к вашей IMAP-почте для синхронизации электронных писем.',
      dropboxAccessTokenTip:
        'Сгенерируйте долговременный токен доступа в консоли приложений Dropbox с областями файлов.metadata.read, files.content.read и sharing.read.',
      moodleDescription:
        'Подключитесь к вашему Moodle LMS для синхронизации содержимого курсов, форумов и ресурсов.',
      moodleUrlTip:
        'Базовый URL вашего экземпляра Moodle (например, https://moodle.university.edu). Не включайте /webservice или /login.',
      moodleTokenTip:
        'Сгенерируйте веб-сервисный токен в Moodle: перейдите в Администрирование сайта → Сервер → Веб-сервисы → Управление токенами. Пользователь должен быть записан на курсы, которые вы хотите синхронизировать.',
      seafileDescription:
        'Подключитесь к вашему SeaFile серверу для синхронизации файлов и документов из ваших библиотек.',
      seafileUrlTip:
        'Базовый URL вашего SeaFile сервера (например, https://seafile.example.com). Не включайте /api2 или другие пути.',
      seafileTokenTip:
        'Создайте API токен в SeaFile: перейдите в Настройки → API Токен → Создать Токен. Токен предоставляет доступ ко всем библиотекам, видимым для вашей учетной записи.',
      seafileIncludeSharedTip:
        'Когда включено, библиотеки, предоставленные вам другими пользователями, также будут синхронизированы.',
      seafileBatchSizeTip:
        'Количество документов для обработки за пакет. Более высокие значения могут улучшить производительность, но использовать больше памяти. По умолчанию: 100.',
      jiraDescription:
        'Подключитесь к вашему Jira workspace для синхронизации задач, комментариев и вложений.',
      jiraBaseUrlTip:
        'Базовый URL вашего сайта Jira (например, https://your-domain.atlassian.net).',
      jiraProjectKeyTip:
        'Дополнительно: ограничьте синхронизацию одним ключом проекта (например, ENG).',
      jiraJqlTip:
        'Дополнительно: фильтр JQL. Оставьте пустым, чтобы полагаться на фильтры проекта/времени.',
      jiraBatchSizeTip:
        'Максимальное количество задач, запрашиваемых из Jira за один пакет.',
      jiraCommentsTip:
        'Включить комментарии Jira в сгенерированный документ в формате markdown.',
      jiraAttachmentsTip:
        'Скачивать вложения как отдельные документы во время синхронизации.',
      jiraAttachmentSizeTip:
        'Вложения, размер которых превышает это значение в байтах, будут пропущены.',
      jiraLabelsTip:
        'Отмеченные метки, которые должны быть пропущены при индексировании (разделены запятыми).',
      jiraBlacklistTip:
        'Комментарии, чей email автора совпадает с этими записями, будут проигнорированы.',
      jiraScopedTokenTip:
        'Включите это при использовании ограниченных токенов Atlassian (api.atlassian.com).',
      jiraEmailTip: 'Email, связанный с аккаунтом Jira/API token.',
      jiraTokenTip:
        'API токен, сгенерированный из https://id.atlassian.com/manage-profile/security/api-tokens.',
      jiraPasswordTip:
        'Дополнительно: пароль для среды Jira Server/Data Center.',
      mysqlDescription:
        'Подключитесь к базе данных MySQL для синхронизации данных из таблиц с использованием SQL-запросов.',
      mysqlQueryTip:
        'SQL-запрос для извлечения данных из вашей базы данных (например, SELECT * FROM products WHERE status = "active").',
      mysqlContentColumnsTip:
        'Имена столбцов, разделенные запятыми, значения которых будут объединены как содержимое документа для векторизации.',
      mysqlMetadataColumnsTip:
        'Имена столбцов, разделенные запятыми, которые будут сохранены как метаданные документа (не векторизуются, но доступны для поиска).',
      mysqlIdColumnTip:
        'Столбец, используемый как уникальный ID документа. Если не указан, будет использован хэш содержимого.',
      mysqlTimestampColumnTip:
        'Столбец даты/времени для инкрементальной синхронизации. Будут извлечены только строки, измененные после последней синхронизации.',
      postgresqlDescription:
        'Подключитесь к базе данных PostgreSQL для синхронизации данных из таблиц с использованием SQL-запросов.',
      postgresqlQueryTip:
        "SQL-запрос для извлечения данных из вашей базы данных (например, SELECT * FROM products WHERE status = 'active').",
      postgresqlContentColumnsTip:
        'Имена столбцов, разделенные запятыми, значения которых будут объединены как содержимое документа для векторизации.',
      postgresqlMetadataColumnsTip:
        'Имена столбцов, разделенные запятыми, которые будут сохранены как метаданные документа (не векторизуются, но доступны для поиска).',
      postgresqlIdColumnTip:
        'Столбец, используемый как уникальный ID документа. Если не указан, будет использован хэш содержимого.',
      postgresqlTimestampColumnTip:
        'Столбец даты/времени для инкрементальной синхронизации. Будут извлечены только строки, измененные после последней синхронизации.',
      availableSourcesDescription: 'Выберите источник данных для добавления',
      availableSources: 'Доступные источники',
      datasourceDescription:
        'Управление вашими источниками данных и подключениями',
      save: 'Сохранить',
      search: 'Поиск',
      availableModels: 'Доступные модели',
      profile: 'Профиль',
      avatar: 'Аватар',
      avatarTip: 'Это будет показано в вашем профиле.',
      profileDescription: 'Обновите фото и персональные данные здесь.',
      maxTokens: 'Макс. токенов',
      maxTokensMessage: 'Укажите максимальное количество токенов',
      maxTokensTip: `Задает максимальную длину вывода модели (в токенах). По умолчанию 512. При отключении ограничение снимается.`,
      maxTokensInvalidMessage: 'Введите корректное число для Макс. токенов.',
      maxTokensMinMessage: 'Макс. токенов не может быть меньше 0.',
      password: 'Пароль',
      passwordDescription: 'Введите текущий пароль для его изменения.',
      model: 'Провайдеры моделей',
      systemModelDescription:
        'Пожалуйста, завершите эти настройки перед началом',
      dataSources: 'Источники данных',
      team: 'Команда',
      system: 'Система',
      logout: 'Выйти',
      api: 'API',
      username: 'Имя пользователя',
      usernameMessage: 'Пожалуйста, введите имя пользователя!',
      photo: 'Ваше фото',
      photoDescription: 'Будет отображаться в вашем профиле.',
      colorSchema: 'Цветовая схема',
      colorSchemaMessage: 'Выберите цветовую схему!',
      colorSchemaPlaceholder: 'выберите цветовую схему',
      bright: 'Светлая',
      dark: 'Темная',
      timezone: 'Часовой пояс',
      timezoneMessage: 'Укажите ваш часовой пояс!',
      timezonePlaceholder: 'выберите часовой пояс',
      email: 'Email',
      emailDescription: 'После регистрации email нельзя изменить.',
      currentPassword: 'Текущий пароль',
      currentPasswordMessage: 'Введите ваш пароль!',
      newPassword: 'Новый пароль',
      changePassword: 'Изменить пароль',
      newPasswordMessage: 'Введите новый пароль!',
      newPasswordDescription: 'Новый пароль должен содержать более 8 символов.',
      confirmPassword: 'Подтвердите пароль',
      confirmPasswordMessage: 'Подтвердите новый пароль!',
      confirmPasswordNonMatchMessage: 'Введенные пароли не совпадают!',
      cancel: 'Отмена',
      addedModels: 'Добавленные модели',
      modelsToBeAdded: 'Доступные модели',
      addTheModel: 'Добавить',
      apiKey: 'API-Key',
      apiKeyMessage:
        'Введите API ключ (для локально развернутой модели можно не указывать).',
      apiKeyTip: 'API ключ можно получить у поставщика LLM.',
      showMoreModels: 'Показать еще',
      baseUrl: 'Base-Url',
      baseUrlTip:
        'Если ваш API ключ от OpenAI, оставьте поле пустым. Другие провайдеры обычно указывают этот URL вместе с ключом.',
      tongyiBaseUrlTip:
        'Для китайских пользователей не нужно заполнять или использовать https://dashscope.aliyuncs.com/compatible-mode/v1. Для международных пользователей используйте https://dashscope-intl.aliyuncs.com/compatible-mode/v1',
      tongyiBaseUrlPlaceholder:
        '(Только для международных пользователей, см. подсказку)',
      minimaxBaseUrlTip:
        'Только для международных пользователей: используйте https://api.minimax.io/v1',
      minimaxBaseUrlPlaceholder:
        '(Только для международных пользователей, заполните https://api.minimax.io/v1)',
      modify: 'Изменить',
      systemModelSettings: 'Настройки моделей по умолчанию',
      chatModel: 'Чат-модель',
      chatModelTip: 'Модель чата по умолчанию для новых баз знаний.',
      embeddingModel: 'Модель эмбеддингов',
      embeddingModelTip:
        'Модель эмбеддингов по умолчанию для новых баз знаний. Если модель не отображается в списке, возможно вы используете облегченную версию RAGu (без моделей эмбеддингов) или проверьте https://ragflow.io/docs/dev/supported_models на поддержку вашим провайдером.',
      img2txtModel: 'Модель img2txt',
      img2txtModelTip:
        'Модель преобразования изображений в текст по умолчанию. Если модель не отображается, проверьте https://ragflow.io/docs/dev/supported_models.',
      sequence2txtModel: 'Модель speech2txt',
      sequence2txtModelTip: 'Модель преобразования речи в текст по умолчанию.',
      rerankModel: 'Модель реранжирования',
      rerankModelTip: `Модель для пересортировки чанков по умолчанию. Проверьте https://ragflow.io/docs/dev/supported_models на поддержку вашим провайдером.`,
      ttsModel: 'TTS-модель',
      ttsModelTip:
        'Модель преобразования текста в речь по умолчанию. Проверьте https://ragflow.io/docs/dev/supported_models на поддержку.',
      workspace: 'Рабочая область',
      upgrade: 'Обновить',
      addLlmTitle: 'Добавить LLM',
      editLlmTitle: 'Редактировать модель {{name}}',
      editModel: 'Редактировать модель',
      modelName: 'Название модели',
      modelID: 'ID модели',
      modelUid: 'UID модели',
      modelNameMessage: 'Введите название модели!',
      modelType: 'Тип модели',
      modelTypeMessage: 'Укажите тип модели!',
      addLlmBaseUrl: 'Базовый URL',
      baseUrlNameMessage: 'Введите базовый URL!',
      paddleocr: {
        apiUrl: 'PaddleOCR API URL',
        apiUrlPlaceholder:
          'Например: https://paddleocr-server.com/layout-parsing',
        accessToken: 'AI Studio Access Token',
        accessTokenPlaceholder: 'Ваш токен AI Studio (необязательно)',
        algorithm: 'PaddleOCR Algorithm',
        selectAlgorithm: 'Выберите алгоритм',
        modelNamePlaceholder: 'Например: paddleocr-from-env-1',
        modelNameRequired: 'Название модели обязательно',
        apiUrlRequired: 'URL API PaddleOCR обязателен',
      },
      vision: 'Поддержка Vision?',
      ollamaLink: 'Интеграция {{name}}',
      FishAudioLink: 'Использование FishAudio',
      TencentCloudLink: 'Использование TencentCloud ASR',
      volcModelNameMessage: 'Введите название модели!',
      addEndpointID: 'EndpointID модели',
      endpointIDMessage: 'Введите EndpointID модели',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Введите ваш ARK_API_KEY',
      bedrockModelNameMessage: 'Введите название модели!',
      addBedrockEngineAK: 'ACCESS KEY',
      bedrockAKMessage: 'Введите ваш ACCESS KEY',
      addBedrockSK: 'SECRET KEY',
      bedrockSKMessage: 'Введите ваш SECRET KEY',
      bedrockRegion: 'AWS Регион',
      bedrockRegionMessage: 'Выберите регион!',
      'us-east-2': 'US East (Ohio)',
      'us-east-1': 'US East (N. Virginia)',
      'us-west-1': 'US West (N. California)',
      'us-west-2': 'US West (Oregon)',
      'af-south-1': 'Africa (Cape Town)',
      'ap-east-1': 'Asia Pacific (Hong Kong)',
      'ap-south-2': 'Asia Pacific (Hyderabad)',
      'ap-southeast-3': 'Asia Pacific (Jakarta)',
      'ap-southeast-5': 'Asia Pacific (Malaysia)',
      'ap-southeast-4': 'Asia Pacific (Melbourne)',
      'ap-south-1': 'Asia Pacific (Mumbai)',
      'ap-northeast-3': 'Asia Pacific (Osaka)',
      'ap-northeast-2': 'Asia Pacific (Seoul)',
      'ap-southeast-1': 'Asia Pacific (Singapore)',
      'ap-southeast-2': 'Asia Pacific (Sydney)',
      'ap-east-2': 'Asia Pacific (Taipei)',
      'ap-southeast-7': 'Asia Pacific (Thailand)',
      'ap-northeast-1': 'Asia Pacific (Tokyo)',
      'ca-central-1': 'Canada (Central)',
      'ca-west-1': 'Canada West (Calgary)',
      'eu-central-1': 'Europe (Frankfurt)',
      'eu-west-1': 'Europe (Ireland)',
      'eu-west-2': 'Europe (London)',
      'eu-south-1': 'Europe (Milan)',
      'eu-west-3': 'Europe (Paris)',
      'eu-south-2': 'Europe (Spain)',
      'eu-north-1': 'Europe (Stockholm)',
      'eu-central-2': 'Europe (Zurich)',
      'il-central-1': 'Israel (Tel Aviv)',
      'mx-central-1': 'Mexico (Central)',
      'me-south-1': 'Middle East (Bahrain)',
      'me-central-1': 'Middle East (UAE)',
      'sa-east-1': 'South America (São Paulo)',
      'us-gov-east-1': 'AWS GovCloud (US-East)',
      'us-gov-west-1': 'AWS GovCloud (US-West)',
      addTencentCloudSID: 'TencentCloud Secret ID',
      TencentCloudSIDMessage: 'Введите ваш Secret ID',
      addTencentCloudSK: 'TencentCloud Secret Key',
      TencentCloudSKMessage: 'Введите ваш Secret Key',
      SparkModelNameMessage: 'Выберите модель Spark',
      addSparkAPIPassword: 'Spark APIPassword',
      SparkAPIPasswordMessage: 'введите ваш APIPassword',
      addSparkAPPID: 'Spark APP ID',
      SparkAPPIDMessage: 'введите ваш APP ID',
      addSparkAPISecret: 'Spark APISecret',
      SparkAPISecretMessage: 'введите ваш APISecret',
      addSparkAPIKey: 'Spark APIKey',
      SparkAPIKeyMessage: 'введите ваш APIKey',
      yiyanModelNameMessage: 'Введите название модели',
      addyiyanAK: 'yiyan API KEY',
      yiyanAKMessage: 'Введите ваш API KEY',
      addyiyanSK: 'yiyan Secret KEY',
      yiyanSKMessage: 'Введите ваш Secret KEY',
      FishAudioModelNameMessage: 'Введите название модели синтеза речи',
      addFishAudioAK: 'Fish Audio API KEY',
      addFishAudioAKMessage: 'Введите ваш API KEY',
      addFishAudioRefID: 'FishAudio Reference ID',
      addFishAudioRefIDMessage:
        'Введите Reference ID (оставьте пустым для модели по умолчанию).',
      GoogleModelIDMessage: 'Введите ID модели!',
      addGoogleProjectID: 'Project ID',
      GoogleProjectIDMessage: 'Введите ваш Project ID',
      addGoogleServiceAccountKey:
        'Service Account Key (пустое для профиля умолчанию)',
      GoogleServiceAccountKeyMessage:
        'Введите Google Cloud Service Account Key в формате base64',
      addGoogleRegion: 'Google Cloud Регион',
      GoogleRegionMessage: 'Введите регион Google Cloud',
      modelProvidersWarn: `Сначала добавьте модели эмбеддингов и LLM в <b>Настройки > Провайдеры моделей</b>, затем настройте их здесь.`,
      apiVersion: 'Версия API',
      apiVersionMessage: 'Введите версию API',
      add: 'Добавить',
      updateDate: 'Дата обновления',
      role: 'Роль',
      invite: 'Пригласить',
      agree: 'Принять',
      refuse: 'Отклонить',
      teamMembers: 'Участники команды',
      joinedTeams: 'Присоединенные команды',
      sureDelete: 'Вы уверены, что хотите удалить этого участника?',
      quit: 'Выйти',
      sureQuit: 'Вы уверены, что хотите покинуть команду?',
      secretKey: 'Секретный ключ',
      publicKey: 'Публичный ключ',
      secretKeyMessage: 'Введите секретный ключ',
      publicKeyMessage: 'Введите публичный ключ',
      hostMessage: 'Введите хост',
      configuration: 'Конфигурация',
      langfuseDescription:
        'Трассировка, оценка, управление промптами и метрики для отладки и улучшения вашего LLM-приложения.',
      viewLangfuseSDocumentation: 'Просмотр документации Langfuse',
      view: 'Просмотр',
      modelsToBeAddedTooltip:
        'Если ваш провайдер моделей не указан, но совместим с OpenAI, выберите карточку "Совместимый с OpenAI API" для добавления соответствующих моделей.',
      mcp: 'MCP',
      mineru: {
        modelNameRequired: 'Название модели обязательно',
        apiServerRequired: 'Конфигурация сервера API MinerU обязательна',
        serverUrlBackendLimit:
          'Адрес сервера MinerU доступен только для HTTP клиентского бэкенда',
        apiserver: 'Конфигурация сервера API MinerU',
        outputDir: 'Путь к выходной директории MinerU',
        backend: 'MinerU Тип бэкенда обработки',
        serverUrl: 'MinerU Сервер URL',
        deleteOutput: 'Удалить выходные файлы после обработки',
        selectBackend: 'Выберите бэкенд обработки',
        backendOptions: {
          pipeline: 'Стандартная обработка через конвейер',
          vlmTransformers: 'Модель зрения и языка с трансформерами',
          vlmVllmEngine: 'Модель зрения и языка с движком vLLM',
          vlmHttpClient: 'Модель зрения и языка через HTTP клиент',
          vlmMlxEngine: 'Модель зрения и языка с движком MLX',
          vlmVllmAsyncEngine:
            'Модель зрения и языка с асинхронным движком vLLM (Экспериментально)',
          vlmLmdeployEngine:
            'Модель зрения и языка с движком LMDeploy (Экспериментально)',
        },
      },
      docling: {
        modelNameRequired: 'Название модели обязательно',
        apiUrlRequired: 'URL API обязателен',
        apiUrl: 'URL API',
        accessToken: 'Токен доступа',
        accessTokenPlaceholder: 'Ваш токен доступа (необязательно)',
        ocrEngine: 'OCR движок',
      },
      modelTypes: {
        chat: 'Chat',
        embedding: 'Embedding',
        rerank: 'Rerank',
        sequence2text: 'sequence2text',
        tts: 'TTS',
        image2text: 'OCR',
        speech2text: 'ASR',
      },
      showToc: 'Показать оглавление',
      hideToc: 'Скрыть оглавление',
    },
    message: {
      registered: 'Зарегистрировано!',
      logout: 'выход',
      logged: 'авторизован!',
      pleaseSelectChunk: 'Пожалуйста, выберите чанк!',
      registerDisabled: 'Регистрация пользователей отключена',
      modified: 'Изменено',
      created: 'Создано',
      deleted: 'Удалено',
      renamed: 'Переименовано',
      operated: 'Выполнено',
      updated: 'Обновлено',
      uploaded: 'Загружено',
      200: 'Сервер успешно вернул запрошенные данные.',
      201: 'Данные успешно созданы или изменены.',
      202: 'Запрос поставлен в очередь (асинхронная задача).',
      204: 'Данные успешно удалены.',
      400: 'Ошибка в запросе, сервер не создал и не изменил данные.',
      401: 'Пожалуйста, войдите снова.',
      403: 'Пользователь авторизован, но доступ запрещен.',
      404: 'Запрошенная запись не существует, сервер не выполнил операцию.',
      406: 'Запрошенный формат недоступен.',
      410: 'Запрошенный ресурс окончательно удален и больше недоступен.',
      413: 'Общий размер загружаемых файлов слишком велик.',
      422: 'При создании объекта произошла ошибка валидации.',
      500: 'Ошибка сервера, пожалуйста, проверьте сервер.',
      502: 'Ошибка шлюза.',
      503: 'Сервис недоступен, сервер перегружен или на обслуживании.',
      504: 'Таймаут шлюза.',
      requestError: 'Ошибка запроса',
      networkAnomalyDescription:
        'Обнаружена аномалия в вашей сети, соединение с сервером невозможно.',
      networkAnomaly: 'сетевая аномалия',
      hint: 'подсказка',
    },
    fileManager: {
      files: 'Файлы',
      name: 'Имя',
      uploadDate: 'Дата загрузки',
      knowledgeBase: 'База знаний',
      size: 'Размер',
      action: 'Действие',
      addToKnowledge: 'Связать с базой знаний',
      pleaseSelect: 'Пожалуйста, выберите',
      newFolder: 'Новая папка',
      file: 'Файл',
      uploadFile: 'Загрузить файл',
      parseOnCreation: 'Обрабатывать при создании',
      directory: 'Директория',
      uploadTitle: 'Перетащите файлы сюда для загрузки',
      uploadDescription:
        'Поддерживается единичная или пакетная загрузка. Для локального RAGu: максимальный размер загрузки - 1GB, до 32 файлов за раз. На demo.ragflow.io: максимальный размер - 10MB, не более 128 файлов на аккаунт.',
      local: 'Локальные загрузки',
      s3: 'S3 загрузки',
      preview: 'Предпросмотр',
      fileError: 'Ошибка файла',
      uploadLimit:
        'Каждый файл не должен превышать 10MB, общее количество файлов - не более 128.',
      destinationFolder: 'Целевая папка',
      pleaseUploadAtLeastOneFile: 'Загрузите хотя бы один файл',
    },
    flow: {
      autoPlay: 'Авто-воспроизведение аудио',
      downloadFileTypeTip: 'Тип файла загрузки',
      downloadFileType: 'Загрузить тип файла',
      formatTypeError: 'Форматировать или вывести ошибку',
      variableNameMessage:
        'Имя переменной может содержать только буквы, подчеркивания и цифры',
      variableDescription: 'Описание переменной',
      defaultValue: 'Значение по умолчанию',
      conversationVariable: 'Переменная диалога',
      recommended: 'Рекомендуется',
      customerSupport: 'Поддержка клиентов',
      marketing: 'Маркетинг',
      consumerApp: 'Пользовательское приложение',
      other: 'Прочее',
      ingestionPipeline: 'Пайплайн обработки',
      agents: 'Агенты',
      days: 'Дни',
      beginInput: 'Начать ввод',
      ref: 'Переменная',
      stockCode: 'Код акции',
      apiKeyPlaceholder:
        'YOUR_API_KEY (полученный от https://serpapi.com/manage-api-key)',
      flowStart: 'Старт',
      flowNum: 'N',
      test: 'Тест',
      extractDepth: 'Извлечение',
      format: 'Форматирование',
      basic: 'Базовый',
      advanced: 'Расширенный',
      general: 'Общий',
      searchDepth: 'Глубина поиска',
      tavilyTopic: 'Tavily topic',
      maxResults: 'Макс результатов',
      includeAnswer: 'Включить ответ',
      includeRawContent: 'Включить исходный контент',
      includeImages: 'Включить изображения',
      includeImageDescriptions: 'Включить описания изображений',
      includeDomains: 'Включить домены',
      ExcludeDomains: 'Исключить домены',
      Days: 'Дни',
      split_ref: 'Указатель разбиения',
      comma: 'Запятая',
      semicolon: 'Точка с запятой',
      period: 'Точка',
      linebreak: 'Перевод строки',
      tab: 'Отступ',
      space: 'Пробел',
      delimiters: 'Разделители',
      mergeDelimitersTip:
        'Разделитель, используемый для объединения элементов массива в одну строку при слиянии.',
      enableChildrenDelimiters:
        'Дочерние фрагменты используются для извлечения',
      merge: 'Объединить',
      split: 'Разделить',
      script: 'Скрипт',
      iterationItemDescription:
        'Представляет текущий элемент в итерации, который может меняться в последующих шагах.',
      guidingQuestion: 'Вопрос руководства',
      onFailure: 'При ошибке',
      userPromptDefaultValue: 'Порядок, который нужно отправить агенту.',
      search: 'Поиск',
      communication: 'Коммуникация',
      developer: 'Разработчик',
      typeCommandORsearch: 'Введите команду или выполните поиск...',
      builtIn: 'Встроенный',
      ExceptionDefaultValue: 'Исключение по умолчанию',
      exceptionMethod: 'Метод исключения',
      maxRounds: 'Максимальное количество раундов рефлексии',
      delayAfterError: 'Задержка после ошибки',
      maxRetries: 'Максимальное количество попыток повтора',
      advancedSettings: 'Расширенные настройки',
      addTools: 'Добавить инструменты',
      sysPromptDefaultValue: `<role>
  Вы - полезный помощник, ИИ-ассистент, специализирующийся на решении проблем для пользователя.
  Если указан конкретный домен, адаптируйте свои знания к этому домену; в противном случае действуйте как универсалист.
</role>
<instructions>
  1. Понимать запрос пользователя.
  2. Декомпозировать его на логические подзадачи.
  3. Выполнять каждую подзадачу шаг за шагом, рассуждая прозрачно.
  4. Проверять точность и согласованность.
  5. Четко резюмировать финальный результат.
</instructions>`,
      singleLineText: 'Однострочный текст',
      multimodalModels: 'Мультимодальные модели',
      textOnlyModels: 'Модели только с текстом',
      allModels: 'Все модели',
      codeExecDescription:
        'Напишите свой собственный Python или Javascript код.',
      stringTransformDescription:
        'Изменяет текстовый контент. В настоящее время поддерживает: разделение или объединение текста.',
      foundation: 'Фундаментальные модели',
      tools: 'Инструменты',
      dataManipulation: 'Манипуляции с данными',
      flow: 'Поток',
      dialog: 'Диалог',
      cite: 'Цитировать',
      citeTip: 'подсказка цитирования',
      name: 'Имя',
      nameMessage: 'Пожалуйста, введите имя',
      description: 'Описание',
      descriptionMessage: 'Агент для задачи.',
      examples: 'Примеры',
      to: 'Кому',
      msg: 'Сообщения',
      msgTip:
        'Выведите содержимое компонента верхнего уровня или текст, введенный вами.',
      messagePlaceholder: 'сообщение',
      messageMsg: 'Пожалуйста, введите сообщение или удалите это поле.',
      addField: 'Добавить опцию',
      addMessage: 'Добавить сообщение',
      loop: 'Цикл',
      loopDescription:
        'Цикл - это максимальное количество итераций для текущего компонента. Если количество итераций превышает это значение, значит компонент не может выполнить текущую задачу и требует оптимизации.',
      exitLoop: 'Выйти из цикла',
      exitLoopDescription: `Эквивалентно "break". У этого узла нет конфигурационных элементов. Когда тело цикла достигает этого узла, цикл завершается.`,
      loopVariables: 'Переменные цикла',
      maximumLoopCount: 'Максимальное количество итераций',
      loopTerminationCondition: 'Условие завершения цикла',
      yes: 'Да',
      no: 'Нет',
      key: 'Ключ',
      componentId: 'ID компонента',
      add: 'Добавить',
      operation: 'операция',
      run: 'Отладка',
      save: 'Сохранить',
      title: 'ID:',
      beginDescription: 'Здесь начинается поток выполнения.',
      answerDescription: `Компонент, служащий интерфейсом между пользователем и ботом, получающий ввод и отображающий ответы агента.`,
      retrievalDescription: `Компонент для поиска информации в указанных базах знаний. Убедитесь, что выбранные базы используют одинаковую модель эмбеддингов.`,
      generateDescription: `Компонент, который запускает LLM для генерации ответов. Убедитесь, что промпт настроен правильно.`,
      categorizeDescription: `Компонент, использующий LLM для категоризации пользовательских запросов по категориям. Для каждой категории укажите название, описание, примеры и следующий компонент.`,
      relevantDescription: `Компонент, оценивающий релевантность вывода предыдущих компонентов текущему запросу. Укажите следующий компонент для каждого возможного результата оценки.`,
      rewriteQuestionDescription: `Компонент, перефразирующий пользовательский запрос с учетом контекста предыдущих диалогов.`,
      messageDescription:
        "Компонент для отправки статического сообщения. При наличии нескольких сообщений выбирает одно случайным образом. Должен быть соединен с компонентом 'Интерфейс'.",
      keywordDescription: `Компонент для поиска TopN результатов по ключевым словам из ввода пользователя. Перед использованием установите значение TopN.`,
      switchDescription: `Компонент для ветвления потока выполнения на основе условий. Позволяет создавать сложную логику, определяя действия для каждого случая и действие по умолчанию.`,
      wikipediaDescription: `Компонент для поиска в wikipedia.org с указанием количества результатов (TopN). Дополняет существующие базы знаний.`,
      promptText: `Обобщите следующие параграфы. Будьте внимательны с числами и фактами. Текст:
        {input}
Конец текста для обобщения.`,
      createGraph: 'Создать агента',
      createFromTemplates: 'Создать из шаблонов',
      retrieval: 'Поиск',
      generate: 'Генерация',
      answer: 'Интерфейс',
      categorize: 'Категоризация',
      rewriteQuestion: 'Перефразировать',
      rewrite: 'Переписать',
      begin: 'Начало',
      message: 'Сообщение',
      blank: 'Пустой',
      createFromNothing: 'Создать агента с нуля',
      addItem: 'Добавить элемент',
      addSubItem: 'Добавить подэлемент',
      nameRequiredMsg: 'Требуется указать имя',
      nameRepeatedMsg: 'Имя должно быть уникальным',
      keywordExtract: 'Ключевые слова',
      keywordExtractDescription: `Компонент для извлечения ключевых слов из запроса с указанием их количества (TopN).`,
      baidu: 'Baidu',
      baiduDescription: `Компонент для поиска на baidu.com с указанием количества результатов (TopN). Дополняет базы знаний.`,
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'Компонент поисковой системы, ориентированной на конфиденциальность, которая не отслеживает действия пользователей и обеспечивает анонимный поиск в Интернете.',
      searXNG: 'SearXNG',
      searXNGDescription:
        'Компонент, который осуществляет поиск через предоставленный URL экземпляра SearXNG. Укажите Top-N и URL экземпляра.',
      pdfGenerator: 'Генератор PDF-документов',
      pDFGenerator: 'Генератор PDF-документов',
      pdfGeneratorDescription: `Компонент, который генерирует документы (PDF, DOCX, TXT) из содержимого в формате markdown с настраиваемым стилем, изображениями и таблицами. Поддерживает: **жирный**, *курсив*, # заголовки, - списки, таблицы с синтаксисом |.`,
      pDFGeneratorDescription: `Компонент, который генерирует документы (PDF, DOCX, TXT) из содержимого в формате markdown с настраиваемым стилем, изображениями и таблицами. Поддерживает: **жирный**, *курсив*, # заголовки, - списки, таблицы с синтаксисом |.`,
      subtitle: 'Подзаголовок',
      logoImage: 'Изображение логотипа',
      logoPosition: 'Позиция логотипа',
      logoWidth: 'Ширина логотипа',
      logoHeight: 'Высота логотипа',
      fontFamily: 'Семейство шрифтов',
      fontSize: 'Размер шрифта',
      titleFontSize: 'Размер шрифта заголовка',
      pageSize: 'Размер страницы',
      orientation: 'Ориентация',
      marginTop: 'Верхний отступ',
      marginBottom: 'Нижний отступ',
      filename: 'Имя файла',
      outputDirectory: 'Каталог вывода',
      addPageNumbers: 'Добавить номера страниц',
      addTimestamp: 'Добавить временную метку',
      watermarkText: 'Текст водяного знака',
      channel: 'Канал',
      channelTip: `Выполняет текстовый или новостной поиск по входным данным компонента`,
      text: 'Текст',
      news: 'Новости',
      messageHistoryWindowSize: 'Размер окна истории сообщений',
      messageHistoryWindowSizeTip:
        'Количество сообщений истории, доступных LLM. Чем больше, тем лучше, но учитывайте ограничения модели на длину контекста.',
      wikipedia: 'Википедия',
      pubMed: 'PubMed',
      pubMedDescription:
        'Компонент для поиска на https://pubmed.ncbi.nlm.nih.gov/ с указанием количества результатов (TopN). Дополняет базы знаний.',
      email: 'Email',
      emailTip: 'Email - обязательное поле. Необходимо указать email-адрес.',
      arXiv: 'ArXiv',
      arXivDescription:
        'Компонент для поиска на https://arxiv.org/ с указанием количества результатов (TopN). Крупнейший архив научных статей.',
      sortBy: 'Сортировать по',
      submittedDate: 'Дата отправки',
      lastUpdatedDate: 'Дата обновления',
      relevance: 'Релевантность',
      google: 'Google',
      googleDescription:
        'Компонент для поиска в Google с указанием количества результатов - N. Требуется API ключ от serpapi.com.',
      yandex: 'Яндекс',
      yandexDescription:
        'Компонент для поиска в Yandex с указанием количества результатов  - N. Требуется API ключ от yandex.ru.',
      folder: 'Папка',
      bing: 'Bing',
      bingDescription:
        'Компонент для поиска в Bing с указанием количества результатов - N. Требуется API ключ от microsoft.com.',
      apiKey: 'API KEY',
      country: 'Страна и регион',
      language: 'Язык',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'Компонент для поиска в Google Scholar с указанием количества результатов (TopN).',
      yearLow: 'Год от',
      yearHigh: 'Год до',
      patents: 'Патенты',
      data: 'Данные',
      deepL: 'DeepL',
      deepLDescription:
        'Компонент для получения специализированных переводов с https://www.deepl.com/.',
      authKey: 'Ключ авторизации',
      sourceLang: 'Исходный язык',
      targetLang: 'Целевой язык',
      gitHub: 'GitHub',
      gitHubDescription:
        'Компонент для поиска репозиториев на GitHub с указанием количества результатов (TopN).',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription:
        'Компонент для получения специализированных переводов с https://fanyi.baidu.com/.',
      appid: 'App ID',
      secretKey: 'Секретный ключ',
      domain: 'Домен',
      transType: 'Тип перевода',
      baiduSecretKeyOptions: {
        translate: 'Общий перевод',
        fieldtranslate: 'Специализированный перевод',
      },
      baiduDomainOptions: {
        it: 'Информационные технологии',
        finance: 'Финансы и экономика',
        machinery: 'Машиностроение',
        senimed: 'Биомедицина',
        novel: 'Онлайн-литература',
        academic: 'Академические работы',
        aerospace: 'Аэрокосмическая отрасль',
        wiki: 'Гуманитарные и социальные науки',
        news: 'Новости и информация',
        law: 'Законы и нормативные акты',
        contract: 'Договоры',
      },
      baiduSourceLangOptions: {
        auto: 'Автоопределение',
        zh: 'Китайский',
        en: 'Английский',
        yue: 'Кантонский',
        wyw: 'Классический китайский',
        jp: 'Японский',
        kor: 'Корейский',
        fra: 'Французский',
        spa: 'Испанский',
        th: 'Тайский',
        ara: 'Арабский',
        ru: 'Русский',
        pt: 'Португальский',
        de: 'Немецкий',
        it: 'Итальянский',
        el: 'Греческий',
        nl: 'Голландский',
        pl: 'Польский',
        bul: 'Болгарский',
        est: 'Эстонский',
        dan: 'Датский',
        fin: 'Финский',
        cs: 'Чешский',
        rom: 'Румынский',
        slo: 'Словенский',
        swe: 'Шведский',
        hu: 'Венгерский',
        cht: 'Традиционный китайский',
        vie: 'Вьетнамский',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'Компонент для получения информации о погоде (температура, качество воздуха) с https://www.qweather.com/.',
      lang: 'Язык',
      type: 'Тип',
      webApiKey: 'Web API ключ',
      userType: 'Тип пользователя',
      timePeriod: 'Период времени',
      qWeatherLangOptions: {
        zh: 'Упрощенный китайский',
        'zh-hant': 'Традиционный китайский',
        en: 'Английский',
        de: 'Немецкий',
        es: 'Испанский',
        fr: 'Французский',
        it: 'Итальянский',
        ja: 'Японский',
        ko: 'Корейский',
        ru: 'Русский',
        hi: 'Хинди',
        th: 'Тайский',
        ar: 'Арабский',
        pt: 'Португальский',
        bn: 'Бенгальский',
        ms: 'Малайский',
        nl: 'Голландский',
        el: 'Греческий',
        la: 'Латинский',
        sv: 'Шведский',
        id: 'Индонезийский',
        pl: 'Польский',
        tr: 'Турецкий',
        cs: 'Чешский',
        et: 'Эстонский',
        vi: 'Вьетнамский',
        fil: 'Филиппинский',
        fi: 'Финский',
        he: 'Иврит',
        is: 'Исландский',
        nb: 'Норвежский',
      },
      qWeatherTypeOptions: {
        weather: 'Прогноз погоды',
        indices: 'Погодные индексы',
        airquality: 'Качество воздуха',
      },
      qWeatherUserTypeOptions: {
        free: 'Бесплатная подписка',
        paid: 'Платная подписка',
      },
      qWeatherTimePeriodOptions: {
        now: 'Сейчас',
        '3d': '3 дня',
        '7d': '7 дней',
        '10d': '10 дней',
        '15d': '15 дней',
        '30d': '30 дней',
      },
      publish: 'API',
      exeSQL: 'ExeSQL',
      exeSQLDescription:
        'Компонент для выполнения SQL-запросов к реляционным базам данных (MySQL, PostgreSQL, MariaDB).',
      dbType: 'Тип БД',
      database: 'База данных',
      username: 'Имя пользователя',
      host: 'Хост',
      port: 'Порт',
      password: 'Пароль',
      outputformat: 'Выходной формат',
      head_n: 'Ограничение записей',
      head_nTip:
        'Количество строк таблицы, возвращаемых для разведочного анализа, максимум 10k',
      chart: 'График',
      chartDescription: 'Компонент построения графической визуализации',
      data_url: 'URL данных',
      width: 'Ширина',
      height: 'Высота',
      widthTip: 'Ширина вывода графика в чат',
      heightTip: 'Высота вывода графика в чат',
      switch: 'Переключатель',
      logicalOperator: 'Логический оператор',
      switchOperatorOptions: {
        equal: 'Равно',
        notEqual: 'Не равно',
        gt: 'Больше',
        ge: 'Больше или равно',
        lt: 'Меньше',
        le: 'Меньше или равно',
        contains: 'Содержит',
        notContains: 'Не содержит',
        startWith: 'Начинается с',
        endWith: 'Заканчивается на',
        empty: 'Пусто',
        notEmpty: 'Не пусто',
        in: 'Включает',
        notIn: 'Не включает',
        is: 'Равно',
        isNot: 'Не равно',
      },
      switchLogicOperatorOptions: {
        and: 'И',
        or: 'ИЛИ',
      },
      operator: 'Оператор',
      value: 'Значение',
      useTemplate: 'Использовать',
      wenCai: 'WenCai',
      queryType: 'Тип запроса',
      wenCaiDescription:
        'Компонент для получения финансовой информации (котировки акций, новости) с различных финансовых сайтов.',
      wenCaiQueryTypeOptions: {
        stock: 'Акции',
        zhishu: 'Индексы',
        fund: 'Фонды',
        hkstock: 'Гонконгские акции',
        usstock: 'Акции США',
        threeboard: 'Внебиржевой рынок',
        conbond: 'Конвертируемые облигации',
        insurance: 'Страхование',
        futures: 'Фьючерсы',
        lccp: 'Финансирование',
        foreign_exchange: 'Иностранная валюта',
      },
      akShare: 'AkShare',
      akShareDescription:
        'Компонент для получения новостей об акциях с https://www.eastmoney.com/.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'Компонент для получения информации о публичных компаниях по их тикеру.',
      crawler: 'Веб-краулер',
      crawlerDescription:
        'Компонент для скачивания HTML-кода с указанного URL.',
      proxy: 'Прокси',
      crawlerResultOptions: {
        html: 'HTML',
        markdown: 'Markdown',
        content: 'Содержимое',
      },
      extractType: 'Тип извлечения',
      info: 'Информация',
      history: 'История',
      financials: 'Финансы',
      balanceSheet: 'Балансовый отчет',
      cashFlowStatement: 'Отчет о движении денежных средств',
      jin10: 'Jin10',
      jin10Description:
        'Компонент для получения финансовой информации с платформы Jin10 (новости, календари, котировки).',
      flashType: 'Тип новостей',
      filter: 'Фильтр',
      contain: 'Содержит',
      calendarType: 'Тип календаря',
      calendarDatashape: 'Формат данных календаря',
      symbolsDatatype: 'Тип данных символов',
      symbolsType: 'Тип символов',
      jin10TypeOptions: {
        flash: 'Экспресс-новости',
        calendar: 'Календарь',
        symbols: 'Котировки',
        news: 'Справочная информация',
      },
      jin10FlashTypeOptions: {
        '1': 'Рыночные новости',
        '2': 'Новости фьючерсов',
        '3': 'Новости США-Гонконг',
        '4': 'Новости акций Китая',
        '5': 'Новости товаров и валют',
      },
      jin10CalendarTypeOptions: {
        cj: 'Календарь макроэкономических данных',
        qh: 'Календарь фьючерсов',
        hk: 'Календарь гонконгских акций',
        us: 'Календарь акций США',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Данные',
        event: 'Событие',
        holiday: 'Праздник',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Котировки товаров',
        FOREX: 'Котировки валют',
        FUTURE: 'Котировки международных рынков',
        CRYPTO: 'Котировки криптовалют',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Список товаров',
        quotes: 'Последние рыночные котировки',
      },
      concentrator: 'Концентратор',
      concentratorDescription:
        'Компонент, который получает выходные данные от вышестоящего компонента и передает их в качестве входных данных для нижестоящих компонентов.',
      tuShare: 'TuShare',
      tuShareDescription:
        'Компонент для получения финансовых новостей с основных финансовых сайтов, полезен для отраслевого и количественного анализа.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'Wall Street CN',
        '10jqka': 'Eastmoney',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Токен',
      src: 'Источник',
      startDate: 'Дата начала',
      endDate: 'Дата окончания',
      keyword: 'Ключевое слово',
      note: 'Примечание',
      noteDescription: 'Примечание',
      notePlaceholder: 'Введите примечание',
      invoke: 'Вызов',
      invokeDescription: `Компонент для вызова удаленных сервисов, использующий выходные данные других компонентов или константы в качестве входных данных.`,
      url: 'URL',
      method: 'Метод',
      timeout: 'Таймаут',
      headers: 'Заголовки',
      cleanHtml: 'Очистить HTML',
      cleanHtmlTip:
        'Если ответ в формате HTML и требуется только основной контент, включите эту опцию.',
      invalidUrl:
        'Должен быть действительный URL или URL с переменными в формате {variable_name} или {component@variable}',
      reference: 'Ссылка',
      input: 'Вход',
      output: 'Выход',
      parameter: 'Параметр',
      howUseId: 'Как использовать ID агента?',
      content: 'Содержимое',
      operationResults: 'Результаты операций',
      autosaved: 'Автосохранено',
      optional: 'Опционально',
      pasteFileLink: 'Вставить ссылку на файл',
      testRun: 'Тестовый запуск',
      template: 'Шаблон',
      templateDescription:
        'Компонент для форматирования вывода других компонентов. 1. Поддерживает шаблоны Jinja2 (преобразует входные данные в объект перед рендерингом), 2. Сохраняет оригинальный метод подстановки строк {parameter}.',
      emailComponent: 'Email',
      emailDescription: 'Отправка email на указанный адрес.',
      smtpServer: 'SMTP сервер',
      smtpPort: 'SMTP порт',
      senderEmail: 'Email отправителя',
      authCode: 'Код авторизации',
      senderName: 'Имя отправителя',
      toEmail: 'Email получателя',
      ccEmail: 'Копия (CC)',
      emailSubject: 'Тема',
      emailContent: 'Содержимое',
      smtpServerRequired: 'Укажите адрес SMTP сервера',
      senderEmailRequired: 'Укажите email отправителя',
      authCodeRequired: 'Укажите код авторизации',
      toEmailRequired: 'Укажите email получателя',
      emailContentRequired: 'Введите содержимое письма',
      emailSentSuccess: 'Email успешно отправлен',
      emailSentFailed: 'Ошибка отправки email',
      dynamicParameters: 'Динамические параметры',
      jsonFormatTip:
        'Вышестоящий компонент должен предоставлять JSON-строку в следующем формате:',
      toEmailTip: 'to_email: Email получателя (Обязательно)',
      ccEmailTip: 'cc_email: Копия (Опционально)',
      subjectTip: 'subject: Тема письма (Опционально)',
      contentTip: 'content: Содержимое письма (Опционально)',
      jsonUploadTypeErrorMessage: 'Загрузите JSON-файл',
      jsonUploadContentErrorMessage: 'Ошибка в JSON-файле',
      iteration: 'Итерация',
      iterationDescription: `Компонент цикла, который перебирает входной массив и выполняет определенную логику для каждого элемента.`,
      delimiterTip: `Этот разделитель используется для разбивки входного текста на части - каждая часть будет обрабатываться отдельно в итерации.`,
      delimiterOptions: {
        comma: 'Запятая',
        linebreak: 'Перенос строки',
        tab: 'Табуляция',
        underline: 'Подчеркивание',
        diagonal: 'Прямой слэш',
        minus: 'Дефис',
        semicolon: 'Точка с запятой',
      },
      addVariable: 'Добавить переменную',
      variableSettings: 'Настройки переменных',
      systemPrompt: 'Системный промпт',
      userPrompt: 'Пользовательский промпт',
      tocDataSource: 'Источник данных',
      addCategory: 'Добавить категорию',
      categoryName: 'Название категории',
      nextStep: 'Следующий шаг',
      variableExtractDescription:
        'Извлекает информацию о пользователе в глобальные переменные в ходе диалога',
      variableExtract: 'Переменные',
      variables: 'Переменные',
      variablesTip: `Задайте переменные в формате JSON с пустыми значениями. Например:
      {
        "UserCode":"",
        "NumberPhone":""
      }`,
      datatype: 'MIME-тип HTTP-запроса',
      insertVariableTip: `Введите / для вставки переменных`,
      historyVersion: 'История версий',
      version: {
        created: 'Создано',
        details: 'Детали версии',
        dsl: 'DSL',
        download: 'Скачать',
        version: 'Версия',
        select: 'Версия не выбрана',
      },
      setting: 'Настройки',
      settings: {
        agentSetting: 'Настройки агента',
        title: 'заголовок',
        description: 'описание',
        upload: 'Загрузить',
        photo: 'Фото',
        permissions: 'Права доступа',
        permissionsTip: 'Настройте права доступа для участников команды.',
        me: 'я',
        team: 'Команда',
      },
      noMoreData: 'Данных больше нет',
      searchAgentPlaceholder: 'Поиск агента',
      footer: {
        profile: 'Все права защищены @ React',
      },
      layout: {
        file: 'файл',
        knowledge: 'знания',
        chat: 'чат',
      },
      prompt: 'Промпт',
      promptTip:
        'Используйте системный промпт для описания задачи LLM, укажите требования к ответу и дополнительные параметры. Промпт может использовать переменные в фигурных скобках {} в качестве входных данных. Нажмите / или кнопку (x) для просмотра доступных переменных.',
      promptMessage: 'Необходимо указать промпт',
      infor: 'Инфо- запуск',
      knowledgeBasesTip:
        'Выберите базы знаний для этого ассистента или укажите переменные, содержащие ID баз знаний.',
      knowledgeBaseVars: 'Переменные баз знаний',
      code: 'Code',
      codeDescription:
        'Разработчики могут использовать это для написания пользовательского Python кода.',
      dataOperations: 'Операции с данными',
      dataOperationsDescription:
        'Выполняет различные операции с объектом данных. Холст должен содержать узлы с выводом в структуру JSON (структурированный вывод)',
      listOperations: 'Операции со списками',
      listOperationsDescription: 'Выполняет операции со списком.',
      variableAssigner: 'Назначение переменных',
      variableAssignerDescription:
        'Компонент выполняет операции с объектами данных, включая извлечение, фильтрацию и редактирование ключей и значений в данных.',
      variableAggregator: 'Агрегатор переменных',
      variableAggregatorDescription: `Этот процесс агрегирует переменные из нескольких ветвей в одну переменную для достижения единой конфигурации для последующих узлов.`,
      inputVariables: 'Входящие переменные',
      runningHintText: 'работает...🕞',
      openingSwitch: 'Приветственное включение',
      openingCopy: 'Приветствие',
      openingSwitchTip:
        'Пользователи будут видеть это приветственное сообщение в начале.',
      modeTip: 'Режим определяет, как запускается рабочий процесс.',
      mode: 'Режим',
      conversational: 'Разговорный',
      task: 'Задача',
      beginInputTip:
        'Определяя входные параметры, это содержимое может быть доступно другим компонентам в последующих процессах.',
      query: 'Переменные запроса',
      switchPromptMessage:
        'Слова промпта изменятся. Пожалуйста, подтвердите, хотите ли вы отменить существующие слова промпта?',
      queryRequired: 'Запрос обязателен',
      queryTip:
        'Выберите переменную, которую вы хотите использовать в качестве запроса.',
      agent: 'Агент',
      addAgent: 'Добавить агента',
      agentDescription:
        'Создает компоненты агента, оборудованные суждением, использованием инструментов и мультиагентной колаборации.',
      maxRecords: 'Максимальное количество записей',
      csvExpirationDays: 'Срок действия ссылки CSV (дни)',
      csvExpirationDaysTip:
        'Как долго действителен предварительно подписанный URL для скачивания (1-7 дней). Файлы удаляются через 30 дней независимо от этого.',
      createAgent: 'Агент',
      stringTransform: 'Обработка текста',
      userFillUp: 'Ожидание ответа',
      userFillUpDescription: `Пауза в рабочем процессе и ожидание сообщения пользователя перед продолжением.`,
      codeExec: 'Код',
      tavilySearch: 'Tavily поиск',
      tavilySearchDescription: 'Поиск результатов через сервис Tavily.',
      tavilyExtract: 'Tavily извлечение',
      tavilyExtractDescription: 'Tavily извлечение',
      log: 'Лог',
      management: 'Управление',
      import: 'Импорт',
      export: 'Экспорт',
      seconds: 'Секунды',
      subject: 'Тема письма',
      tag: 'Тэг',
      tagPlaceholder: 'Введите тэг',
      descriptionPlaceholder: 'Введите описание',
      line: 'Однострочный текст',
      paragraph: 'Многострочный текст',
      options: 'Выпадающий список',
      file: 'Загрузка файла',
      integer: 'Число',
      boolean: 'Булево значение',

      logTimeline: {
        begin: 'Готов к началу',
        agent: 'Агент думает',
        userFillUp: 'Ожидание ответа',
        retrieval: 'Поиск знаний',
        message: 'Агент говорит',
        awaitResponse: 'Ожидание ответа',
        switch: 'Выбор лучшего пути',
        iteration: 'Пакетная обработка',
        categorize: 'Категоризация информации',
        code: 'Запуск скрипта',
        textProcessing: 'Обработка текста',
        tavilySearch: 'Поиск в интернете',
        tavilyExtract: 'Чтение страницы',
        exeSQL: 'Запрос к базе данных',
        google: 'Поиск в интернете',
        wikipedia: 'Поиск в Википедии',
        googleScholar: 'Академический поиск',
        gitHub: 'Поиск в GitHub',
        email: 'Отправка email',
        httpRequest: 'Вызов API',
        wenCai: 'Запрос финансовых данных',
      },
      goto: 'Отказ ветви',
      comment: 'Значения по-умолчанию',
      sqlStatement: 'SQL выражение',
      sqlStatementTip:
        'Напишите ваш SQL запрос здесь. Вы можете использовать переменные, обычный SQL или смешивать оба варианта с использованием синтаксиса переменных.',
      frameworkPrompts: 'Фреймворк',
      release: 'Публиковать',
      createFromBlank: 'Создать с нуля',
      createFromTemplate: 'Создать из шаблона',
      importJsonFile: 'Импортировать JSON файл',
      ceateAgent: 'Агент',
      createPipeline: 'Пайплайн загрузки',
      chooseAgentType: 'Выберите тип агента',
      parser: 'Парсер',
      parserDescription:
        'Извлекает необработанный текст и структуру из файлов для последующей обработки.',
      tokenizer: 'Индексатор',
      tokenizerRequired: 'Пожалуйста, сначала добавьте узел Индексатора',
      tokenizerDescription:
        'Преобразует текст в требуемую структуру данных (например, векторные эмбеддинги для поиска по эмбеддингам) в зависимости от выбранного метода поиска.',
      splitter: 'Токен',
      splitterDescription:
        'Разбивает текст на части по длине токенов с необязательными разделителями и перекрытием.',
      hierarchicalMergerDescription:
        'Разбивает документы на разделы по иерархии заголовков с регулярными выражениями для более точного управления.',
      hierarchicalMerger: 'Название',
      extractor: 'Трансформер',
      extractorDescription:
        'Использует LLM для извлечения структурированных артефактов из фрагментов документов — таких как резюме, классификации и т.д.',
      outputFormat: 'Output format',
      fileFormats: 'Тип файла',
      fileFormatOptions: {
        pdf: 'PDF',
        spreadsheet: 'Таблица',
        image: 'Изображение',
        email: 'Email',
        'text&markdown': 'Текст & Разметка',
        word: 'Word',
        slides: 'PPTX',
        audio: 'Аудио',
        video: 'Видео',
      },
      fields: 'Поле',
      addParser: 'Добавить парсер',
      hierarchy: 'Иерархия',
      regularExpressions: 'Регулярные выражения',
      overlappedPercent: 'Процент перекрытия (%)',
      searchMethod: 'Метод поиска',
      searchMethodTip: `Определяет, как можно искать содержимое — по полному тексту, эмбеддингу или обоим.
Индексатор будет хранить содержимое в соответствующих структурах данных для выбранных методов.`,
      // file: 'File',
      parserMethod: 'PDF парсер',
      tableResultType: 'Тип результата таблицы',
      markdownImageResponseType: 'Тип изображения в Markdown',
      // systemPrompt: 'System Prompt',
      systemPromptPlaceholder:
        'Ввведите системный запрос для анализа изображения, если пусто, будет использовано значение по умолчанию',
      exportJson: 'Экспорт JSON',
      viewResult: 'Просмотр результата',
      running: 'Выполняется',
      summary: 'Резюме',
      keywords: 'Ключевые слова',
      questions: 'Вопросы',
      metadata: 'Метаданные',
      toc: 'Оглавление',
      fieldName: 'Назначение результата',
      prompts: {
        system: {
          keywords: `Роль
Ты анализатор текста.

Задача
Извлечь самые важные ключевые слова/фразы из заданного текстового содержимого.

Требования
- Обобщить текстовое содержимое и указать 5 самых важных ключевых слов/фраз.
- Ключевые слова ДОЛЖНЫ быть на том же языке, что и заданное текстовое содержимое.
- Ключевые слова разделяются запятыми.
- Выводить только ключевые слова.`,
          questions: `Роль
Ты анализатор текста.

Задача
Предложить 3 вопроса о заданном текстовом содержимом.

Требования
- Понять и обобщить текстовое содержимое, и предложить 3 важных вопроса.
- Вопросы не должны пересекаться по смыслу.
- Вопросы должны охватывать основное содержание текста.
- Вопросы должны быть на том же языке, что и заданное текстовое содержимое.
- Один вопрос на строку.
- Выводить только вопросы.`,
          summary: `Действуй как точный обозреватель. Твоя задача — создать краткое содержание предоставленного текста, которое будет одновременно кратким и верным оригиналу.

Ключевые инструкции:
1. Точность: строго основываться на предоставленной информации. Не добавлять новые факты, выводы или интерпретации, которые не были явно указаны.
2. Язык: писать резюме на том же языке, что и исходный текст.
3. Объективность: представлять ключевые моменты без предвзятости, сохраняя оригинальный замысел и тон содержания. Не делать редактирование.
4. Краткость: сосредоточиться на самых важных идеях, опустив второстепенные детали и лишнее.`,
          metadata: `Извлеки важную структурированную информацию из заданного содержимого. Выведи только действительную строку JSON без дополнительного текста. Если важная структурированная информация не найдена, выведи пустой JSON объект: {}.

Важная структурированная информация может включать: имена, даты, места, события, ключевые факты, числовые данные или другие извлекаемые сущности.`,
          toc: '',
        },
        user: {
          keywords: `Text Content
[Вставьте текст здесь]`,
          questions: `Text Content
[Вставьте текст здесь]`,
          summary: `Text to Summarize:
[Вставьте текст здесь]`,
          metadata: `Content: [ВСТАВЬТЕ СОДЕРЖИМОЕ ЗДЕСЬ]`,
          toc: '[Вставьте текст здесь]',
        },
      },
      cancel: 'Отменить',
      swicthPromptMessage:
        'Промпт будет изменен. Пожалуйста, подтвердите, хотите ли вы отказаться от текущего промпта?',
      tokenizerSearchMethodOptions: {
        full_text: 'Полнотекстовый поиск',
        embedding: 'Эмбеддинг поиск',
      },
      filenameEmbeddingWeight: 'Вес эмбеддинга имени файла',
      tokenizerFieldsOptions: {
        text: 'Обработанный текст',
        keywords: 'Ключевые слова',
        questions: 'Вопросы',
        summary: 'Обобщенное содержание',
      },
      imageParseMethodOptions: {
        ocr: 'OCR',
      },
      structuredOutput: {
        configuration: 'Конфигурация',
        structuredOutput: 'Структурированный вывод',
      },
      operations: 'Операции',
      operationsOptions: {
        selectKeys: 'Выбрать ключи',
        literalEval: 'Оценка литерала',
        combine: 'Комбинировать',
        filterValues: 'Фильтровать значения',
        appendOrUpdate: 'Добавить или обновить',
        removeKeys: 'Удалить ключи',
        renameKeys: 'Переименовать ключи',
      },
      ListOperationsOptions: {
        topN: 'Top-N',
        head: 'Головные',
        tail: 'Хвостовые',
        sort: 'Сортировать',
        filter: 'Фильтровать',
        dropDuplicates: 'Исключить дубликаты',
      },
      sortMethod: 'Метод сортировки',
      SortMethodOptions: {
        asc: 'По возрастанию',
        desc: 'По убыванию',
      },
      variableAssignerLogicalOperatorOptions: {
        overwrite: 'Переписать',
        clear: 'Очистить',
        set: 'Установить',
        add: 'Добавить',
        subtract: 'Вычесть',
        multiply: 'Умножить',
        divide: 'Разделить',
        append: 'Присоединить',
        extend: 'Расширить',
        removeFirst: 'Удалить первый',
        removeLast: 'Удалить последний',
      },
      webhook: {
        name: 'Вебхук',
        methods: 'Методы',
        contentTypes: 'Типы содержимого',
        security: 'Безопасность',
        schema: 'Схема',
        response: 'Ответ',
        executionMode: 'Режим выполнения',
        executionModeTip:
          'Получаемый ответ: Система возвращает подтверждение сразу после проверки запроса, в то время как рабочий процесс продолжает выполняться асинхронно в фоне. /Финальный ответ: Система возвращает ответ только после завершения выполнения рабочего процесса.',
        authMethods: 'Методы аутентификации',
        authType: 'Тип аутентификации',
        limit: 'Лимит запросов',
        per: 'Временной период',
        maxBodySize: 'Максимальный размер тела запроса',
        ipWhitelist: 'IP белый список',
        tokenHeader: 'Заголовок токена',
        tokenValue: 'Значение токена',
        username: 'Имя пользователя',
        password: 'Пароль',
        algorithm: 'Алгоритм',
        secret: 'Секрет',
        issuer: 'Издатель',
        audience: 'Аудитория',
        requiredClaims: 'Требуемые заявления',
        header: 'Заголовок',
        status: 'Статус',
        headersTemplate: 'Шаблон заголовков',
        bodyTemplate: 'Шаблон тела',
        basic: 'Базовый',
        bearer: 'Носитель',
        apiKey: 'Api ключ',
        queryParameters: 'Параметры запроса',
        headerParameters: 'Параметры заголовка',
        requestBodyParameters: 'Параметры тела запроса',
        immediately: 'Принятый ответ',
        streaming: 'Финальный ответ',
        overview: 'Обзор',
        logs: 'Логи',
        agentStatus: 'Статус агента',
      },
      saveToMemory: 'Сохранить в память',
      retrievalFrom: 'Извлечение из',
    },
    llmTools: {
      bad_calculator: {
        name: 'Калькулятор',
        description:
          'Инструмент для вычисления суммы двух чисел (даст неправильный ответ)',
        params: {
          a: 'Первое число',
          b: 'Второе число',
        },
      },
    },
    modal: {
      okText: 'Подтвердить',
      cancelText: 'Отменить',
    },
    mcp: {
      export: 'Экспорт',
      import: 'Импорт',
      url: 'URL',
      serverType: 'Тип сервера',
      addMCP: 'Добавить MCP',
      editMCP: 'Редактировать MCP',
      toolsAvailable: 'Доступные инструменты',
      mcpServers: 'MCP серверы',
      mcpServer: 'MCP сервер',
      customizeTheListOfMcpServers: 'Настроить список MCP серверов',
      cachedTools: 'инструменты в кеше',
      bulkManage: 'Пакетное управление',
      exitBulkManage: 'Выйти из пакетного управления',
      selected: 'Выбранный',
    },
    search: {
      searchApps: 'Поиск',
      createSearch: 'Создать поиск',
      searchGreeting: 'Введите запрос для поиска',
      profile: 'Скрыть профиль',
      locale: 'Язык',
      embedCode: 'Встроить код',
      id: 'ID',
      copySuccess: 'Скопировать',
      welcomeBack: 'С возвращением',
      searchSettings: 'Настройки поиска',
      name: 'Имя',
      avatar: 'Аватар',
      description: 'Описание',
      datasets: 'Данные',
      rerankModel: 'Модель переранжирования',
      AISummary: 'AI обзор',
      enableWebSearch: 'Использовать веб-поиск',
      enableRelatedSearch: 'Использовать связанный поиск',
      showQueryMindmap: 'Показать карту запроса',
      embedApp: 'Опубликовать',
      relatedSearch: 'Связанный поиск',
      descriptionValue: 'Ты интеллектуальный помощник.',
      okText: 'Сохранить',
      cancelText: 'Отменить',
      chooseDataset: 'Пожалуйста, выберите данные',
    },
    language: {
      english: 'Английский',
      chinese: 'Китайский',
      spanish: 'Испанский',
      french: 'Французский',
      german: 'Немецкий',
      japanese: 'Японский',
      korean: 'Корейский',
      vietnamese: 'Вьетнамский',
      russian: 'Русский',
    },
    pagination: {
      total: 'Всего {{total}}',
      page: '{{page}} /Страниц',
    },
    dataflowParser: {
      result: 'Результат',
      parseSummary: 'Обзор разбора',
      parseSummaryTip: 'Парсер：DeepDoc',
      parserMethod: 'Метод парсера',
      outputFormat: 'Формат вывода',
      rerunFromCurrentStep: 'Перезапустить с текущего шага',
      rerunFromCurrentStepTip:
        'Обнаружены изменения. Нажмите, чтобы перезапустить.',
      confirmRerun: 'Подтвердить перезапуск процесса',
      confirmRerunModalContent: `
<p class="text-sm text-text-disabled font-medium mb-2">
  Вы собираетесь перезапустить процесс, начиная с шага <span class="text-text-secondary">{{step}}</span>.
</p>
<p class="text-sm mb-3 text-text-disabled">Это приведет к:</p><br />
<ul class="list-disc list-inside space-y-1 text-sm text-text-secondary">
  <li>• Перезаписи существующих результатов с текущего шага и далее</li>
  <li>• Созданию новой записи журнала для отслеживания</li>
  <li>• Предыдущие шаги останутся без изменений</li>
</ul>`,
      changeStepModalTitle: 'Оповещение о смене шага',
      changeStepModalContent: `
<p>Вы редактируете результаты этого этапа.</p>
<p>Если вы переключитесь на более поздний этап, ваши изменения будут потеряны.</p>
<p>Чтобы сохранить их, нажмите "Перезапустить", чтобы перезапустить текущий этап.</p> `,
      changeStepModalConfirmText: 'Переключить',
      changeStepModalCancelText: 'Отменить',
      unlinkPipelineModalTitle: 'Открепить пайплайн',
      unlinkPipelineModalConfirmText: 'Открепить',
      unlinkPipelineModalContent: `
<p>При откреплении набор данных не будет больше подключен к текущему пайплайну.</p>
<p>Файлы, которые уже обрабатываются, будут обработаны</p>
<p>Файлы, которые еще не обрабатываются, будут запущены</p> <br/>
<p>Вы уверены, что хотите продолжить?</p> `,
      unlinkSourceModalTitle: 'Открепить источник данных',
      unlinkSourceModalContent: `
<p>Вы уверены, что хотите открепить этот источник данных?</p>`,
      unlinkSourceModalConfirmText: 'Открепить',
    },
    datasetOverview: {
      downloadTip: 'Файлы, которые загружаются из источников данных.',
      processingTip: 'Файлы, которые обрабатываются пайплайном.',
      totalFiles: 'Всего файлов',
      downloading: 'Загрузка',
      downloadSuccessTip: 'Всего успешных загрузок',
      downloadFailedTip: 'Всего неудачных загрузок',
      processingSuccessTip: 'Всего успешно обработанных файлов',
      processingFailedTip: 'Всего неудачных обработок',
      processing: 'Обработка',
      noData: 'Нет логов еще',
    },

    deleteModal: {
      delAgent: 'Удалить агента',
      delDataset: 'Удалить данные',
      delSearch: 'Удалить поиск',
      delFile: 'Удалить файл',
      delFiles: 'Удалить файлы',
      delFilesContent: 'Выбрано {{count}} файлов',
      delChat: 'Удалить чат',
      delMember: 'Удалить участника',
      delMemory: 'Удалить память',
    },

    empty: {
      noMCP: 'Нет доступных серверов MCP',
      agentTitle: 'Агент еще не создан',
      notFoundAgent: 'Агент не найден',
      datasetTitle: 'Данные еще не созданы',
      notFoundDataset: 'Данные не найдены',
      chatTitle: 'Чат еще не создан',
      notFoundChat: 'Чат-приложение не найдено',
      searchTitle: 'Приложение поиска еще не создано',
      notFoundSearch: 'Приложение поиска не найдено',
      memoryTitle: 'Память еще не создана',
      notFoundMemory: 'Память не найдена',
      addNow: 'Добавить сейчас',
    },

    admin: {
      loginTitle: 'Консоль администратора',
      title: 'RAGu',
      confirm: 'Подтвердить',
      close: 'Закрыть',
      yes: 'Да',
      no: 'Нет',
      delete: 'Удалить',
      cancel: 'Отменить',
      reset: 'Сбросить',
      import: 'Импорт',
      description: 'Описание',
      noDescription: 'Нет описания',

      resourceType: {
        dataset: 'Данные',
        chat: 'Чат',
        agent: 'Агент',
        search: 'Поиск',
        file: 'Файл',
        team: 'Команда',
        memory: 'Память',
      },

      permissionType: {
        enable: 'Включить',
        read: 'Читать',
        write: 'Записатьь',
        share: 'Поделиться',
      },

      serviceStatus: 'Статус сервиса',
      userManagement: 'Управление пользователями',
      sandboxSettings: 'Настройки песочницы',
      registrationWhitelist: 'Белый список регистрации',
      roles: 'Роли',
      monitoring: 'Мониторинг',

      back: 'Назад',
      active: 'Активный',
      inactive: 'Неактивный',
      enable: 'Включить',
      disable: 'Отключить',
      all: 'Все',
      actions: 'Действия',
      newUser: 'Новый пользователь',
      email: 'Email',
      name: 'Имя',
      nickname: 'Никнейм',
      status: 'Статус',
      id: 'ID',
      serviceType: 'Тип сервиса',
      host: 'Хост',
      port: 'Порт',

      role: 'Роль',
      user: 'Пользователь',
      userType: 'Тип пользователя',
      superuser: 'Суперпользователь',
      normalUser: 'Обычный пользователь',

      createTime: 'Время создания',
      lastLoginTime: 'Время последнего входа',
      lastUpdateTime: 'Время последнего обновления',

      isAnonymous: 'Анонимный',
      isSuperuser: 'Суперпользователь',

      deleteUser: 'Удалить пользователя',
      deleteUserConfirmation:
        'Вы уверены, что хотите удалить этого пользователя?',

      createNewUser: 'Создать нового пользователя',
      changePassword: 'Изменить пароль',
      newPassword: 'Новый пароль',
      confirmNewPassword: 'Подтвердить новый пароль',
      password: 'Пароль',
      confirmPassword: 'Подтвердить пароль',

      invalidEmail: 'Введите действительный адрес электронной почты!',
      passwordRequired: 'Введите ваш пароль!',
      passwordMinLength: 'Пароль должен быть длиннее 8 символов.',
      confirmPasswordRequired: 'Подтвердите ваш пароль!',
      confirmPasswordDoNotMatch: 'Введенные пароли не совпадают!',

      read: 'Читать',
      write: 'Записать',
      share: 'Поделиться',
      create: 'Создать',

      extraInfo: 'Дополнительная информация',
      serviceDetail: `Детали сервиса {{name}}`,
      taskExecutorDetail: 'Детали исполнителя задачи',

      whitelistManagement: 'Управление белым списком',
      exportAsExcel: 'Экспорт Excel',
      importFromExcel: 'Импорт Excel',
      createEmail: 'Создать email',
      deleteEmail: 'Удалить email',
      editEmail: 'Редактировать email',
      deleteWhitelistEmailConfirmation:
        'Вы уверены, что хотите удалить этот email из белого списка? Это действие нельзя отменить.',

      importWhitelist: 'Импорт белого списка (Excel)',
      importSelectExcelFile: 'Excel файл (.xlsx)',
      importOverwriteExistingEmails: 'Переопределить существующие email',
      importInvalidExcelFile: 'Выберите корректный Excel файл',
      importFileRequired: 'Выберите файл для импорта',
      importFileTips:
        'Файл должен содержать один заголовок с названием <code>email</code>.',

      chunkNum: 'Чанки',
      docNum: 'Документы',
      tokenNum: 'Использовано токенов',
      language: 'Язык',
      createDate: 'Дата создания',
      updateDate: 'Дата обновления',
      permission: 'Разрешение',

      agentTitle: 'Имя агента',
      canvasCategory: 'Категория холста',

      newRole: 'Новая роль',
      addNewRole: 'Добавить новую роль',
      roleName: 'Имя роли',
      roleNameRequired: 'Имя роли обязательно',
      resources: 'Ресурсы',

      editRoleDescription: 'Редактировать описание роли',
      deleteRole: 'Удалить роль',
      deleteRoleConfirmation:
        'Вы уверены, что хотите удалить эту роль? Это действие нельзя отменить.',

      alive: 'Живой',
      timeout: 'Лимит времени',
      fail: 'Отказ',
    },
    explore: {
      title: 'Запуск',
      canvasList: 'Список холстов',
      sessions: 'Сессии',
      newSession: 'Новая сессия',
      newSessionLabel: 'Начать новый разговор',
      deleteSession: 'Удалить сессию',
      searchCanvas: 'Поиск холста...',
      searchSessions: 'Поиск сессий...',
      noCanvasSelected: 'Пожалуйста, выберите холст',
      noSessionSelected: 'Пожалуйста, выберите сессию или создайте новую',
      noSessionsFound: 'Сессии не найдены',
      createFirstSession: 'Создайте свою первую сессию',
      noCanvasFound: 'Холсты не найдены',
      deleteSelectedConfirm:
        'Вы уверены, что хотите удалить {{count}} сессий(ю)?',
      batchDeleteSessions: 'Удалить сессии',
    },
  },
};
